/* 9 Oct 2026, faster pictures (his request: compress all images, speed up the loading). The store's CDN already sends WebP or AVIF to every browser that takes it,
   so the format was never the cost: the SIZE was. A 1,400 px gallery picture was sent for a 324 px thumbnail. The CDN resizes on
   request (&width=N on any picture address), so the thumbnails and the phone carousel ask for what they show. The large picture
   (#g53) and the viewer keep the full file. sized() only adds or replaces the width; SVG and video are left alone. */
window.SolveSized=function(u,w){ if(!u||/\.(svg|mp4|webm|gif)(\?|$)/i.test(u)||/^data:/.test(u)) return u;
  if(/[?&]width=\d+/.test(u)) return u.replace(/([?&]width=)\d+/,function(m,p,o){ return p+w; });
  return u+(u.indexOf('?')<0?'?':'&')+'width='+w; };
/* ══ SUBSCRIPTION FREQUENCY (add_sub_frequency.py) ══ */
/* Lion's Mane PDP — 58c13 bundle. Blocks concatenated in document
   order; loaded with defer, so every IIFE runs after parse. */
/* Shared presentment-currency formatter. This store runs Shopify Markets, so
   the price a visitor is quoted may be EUR rather than GBP — the currency is
   read from the same Liquid-rendered payload the buy box uses, never assumed. */
window.SolveMoney=(function(){
  var SYM='£', pre=true, thou=',', dec='.';
  try{
    var d=JSON.parse(document.getElementById('pdp-formats').textContent);
    if(d&&d.shop){
      SYM=d.shop.symbol||SYM;
      /* sample is 1,234.56 as Shopify itself renders it in this market */
      var s=d.shop.sample||'';
      var digits=s.replace(/[^0-9.,\s]/g,'').trim();
      if(digits){
        pre = s.indexOf(digits.charAt(0)) > 0;
        var seps=digits.replace(/[0-9\s]/g,'');      /* e.g. ".," or ",." or "," */
        if(seps.length>=2){ thou=seps.charAt(0); dec=seps.charAt(seps.length-1); }
        else if(seps.length===1){ dec=seps; thou=(dec===','?'.':','); }
      }
    }
  }catch(e){}
  return function(v){
    v=Number(v)||0;
    var neg=v<0; v=Math.abs(v);
    var parts=v.toFixed(2).split('.');
    var whole=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    var out=whole+(parts[1]==='00'?'':dec+parts[1]);
    out=pre?(SYM+out):(out+' '+SYM);
    return neg?('-'+out):out;
  };
})();


(function(){
  var a=document.querySelector('.auda'); if(!a) return;
  a.classList.add('js');
  if(!('IntersectionObserver' in window)){a.classList.add('in');return;}
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ a.classList.add('in'); io.disconnect(); } });
  },{threshold:.3});
  io.observe(a);
})();


(function(){
  var sec=document.querySelector('.proto'); if(!sec) return;
  var tabs=[].slice.call(sec.querySelectorAll('.proto-tab'));
  var panels=[].slice.call(sec.querySelectorAll('.proto-panel'));
  function show(name){
    tabs.forEach(function(t){ t.classList.toggle('on', t.getAttribute('data-tab')===name); });
    panels.forEach(function(p){ p.hidden = p.getAttribute('data-panel')!==name; });
  }
  tabs.forEach(function(t){ t.addEventListener('click', function(){ show(t.getAttribute('data-tab')); }); });
  /* graph is the default tab — draw it when the card scrolls into view */
  var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ sec.classList.add('in'); io.disconnect(); } }); },{threshold:.25});
  io.observe(sec);
})();


/* reviews filter chips + numbered pagination */
(function(){
  var wrap=document.querySelector('.rev-tags'), grid=document.querySelector('.rev-grid'), pager=document.getElementById('revPager');
  if(!wrap||!grid) return;
  var cards=[].slice.call(grid.querySelectorAll('.rev-card'));
  var PER=6, filter='all', starF=0, page=1;
  function starsOf(c){ var t=c.querySelector('.st'); return t ? (t.textContent.match(/★/g)||[]).length : 0; }
  function matched(){ return cards.filter(function(c){
    var ok = filter==='all' || (' '+(c.getAttribute('data-tags')||'')+' ').indexOf(' '+filter+' ')>-1;
    return ok && (!starF || starsOf(c)===starF);
  }); }
  /* breakdown rows filter by star count; click again to clear */
  var bars=[].slice.call(document.querySelectorAll('.rev-bar'));
  bars.forEach(function(row,i){
    row.setAttribute('role','button'); row.setAttribute('tabindex','0');
    function go(){
      var v=5-i;
      starF=(starF===v)?0:v;
      bars.forEach(function(rr,j){ rr.classList.toggle('on', starF===5-j); });
      page=1; render();
      grid.scrollIntoView({behavior:'smooth',block:'start'});
    }
    row.addEventListener('click',go);
    row.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){e.preventDefault();go();} });
  });
  function buildPager(pages){
    if(!pager) return;
    if(pages<=1){ pager.innerHTML=''; pager.hidden=true; return; }
    pager.hidden=false;
    var h='<button type="button" class="rev-pg rev-pg-arrow" data-pg="prev" aria-label="Previous"'+(page===1?' disabled':'')+'>&lsaquo;</button>';
    for(var i=1;i<=pages;i++){ h+='<button type="button" class="rev-pg'+(i===page?' on':'')+'" data-pg="'+i+'"'+(i===page?' aria-current="page"':'')+'>'+i+'</button>'; }
    h+='<button type="button" class="rev-pg rev-pg-arrow" data-pg="next" aria-label="Next"'+(page===pages?' disabled':'')+'>&rsaquo;</button>';
    pager.innerHTML=h;
  }
  function render(){
    var m=matched(), pages=Math.max(1,Math.ceil(m.length/PER));
    if(page>pages) page=pages;
    cards.forEach(function(c){ c.style.display='none'; });
    m.slice((page-1)*PER, (page-1)*PER+PER).forEach(function(c){ c.style.display=''; });
    buildPager(pages);
  }
  wrap.addEventListener('click',function(e){
    var b=e.target.closest('button[data-f]'); if(!b) return;
    [].forEach.call(wrap.querySelectorAll('button'),function(c){ c.classList.toggle('on',c===b); });
    filter=b.getAttribute('data-f'); page=1; render();
  });
  if(pager) pager.addEventListener('click',function(e){
    var b=e.target.closest('button[data-pg]'); if(!b||b.disabled) return;
    var v=b.getAttribute('data-pg'), pages=Math.max(1,Math.ceil(matched().length/PER));
    if(v==='prev') page=Math.max(1,page-1);
    else if(v==='next') page=Math.min(pages,page+1);
    else page=parseInt(v,10);
    render();
    var g=document.querySelector('.rev-tags'); if(g&&g.scrollIntoView) g.scrollIntoView({behavior:'smooth',block:'center'});
  });
  render();
})();


(function(){
  var lbx=document.getElementById('lbx'), img=document.getElementById('lbxImg');
  if(!lbx) return;
  function close(){ lbx.classList.remove('on'); document.body.style.overflow=''; }
  document.addEventListener('click',function(e){
    var t=e.target.closest('.rev-photos img, .rev-card .thumb');
    if(t){ img.src=t.currentSrc||t.src; lbx.classList.add('on'); document.body.style.overflow='hidden'; return; }
    if(e.target.closest('.lbx')) close();
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&lbx.classList.contains('on')) close(); });
})();


(function(){
  var p=document.querySelector('.people'); if(!p) return;
  p.classList.add('reveal');
  if(!('IntersectionObserver' in window)){ p.classList.add('in'); return; }
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ p.classList.add('in'); io.disconnect(); } });
  },{threshold:.15});
  io.observe(p);
})();


/* full-width Brain Stack — same live-total behaviour as the rail bundle */
(function(){
  var stk=document.getElementById('bstk'), cta=document.getElementById('bstkCta');
  if(!stk||!cta) return;
  function money(n){ return window.SolveMoney(n); }
  function sync(){
    var n=0, tot=0;
    [].forEach.call(stk.querySelectorAll('.bsc'),function(it){
      if(it.querySelector('input').checked){ n++; tot+=parseFloat(it.dataset.price); }
    });
    if(n===0){ cta.disabled=true; cta.innerHTML='Select an item to add'; }
    else{ cta.disabled=false; cta.innerHTML='Add '+n+' to your order &mdash; '+money(tot); }
  }
  stk.addEventListener('change',function(e){ if(e.target.matches('input')) sync(); });
  sync();
})();
/* staggered scroll-reveal for the Brain Stack */
(function(){
  var b=document.querySelector('.bstack'); if(!b) return;
  b.classList.add('reveal');
  if(!('IntersectionObserver' in window)){ b.classList.add('in'); return; }
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ b.classList.add('in'); io.disconnect(); } });
  },{threshold:.15});
  io.observe(b);
})();


/* mobile sticky add-to-basket: appears once the buy box scrolls past,
   mirrors the live price, and proxies the real Add button */
(function(){
  var bar=document.getElementById('matc'), buy=document.querySelector('.va-buy'),
      add=document.getElementById('add37');
  if(!bar||!buy||!add) return;
  function upd(){
    var past=buy.getBoundingClientRect().bottom<0;
    bar.classList.toggle('on',past);
    bar.setAttribute('aria-hidden',past?'false':'true');
  }
  addEventListener('scroll',upd,{passive:true});
  addEventListener('resize',upd);
  upd();
  /* mirror price + format from the fold's live nodes */
  function sync(){
    var pr=document.getElementById('vacta'), cap=document.getElementById('g57cap'),
        sub=document.querySelector('#optSub.on');
    if(pr) document.getElementById('matcPr').textContent=pr.textContent;
    /* the sticky bar names the SPECIES of the page it is on — this bundle is
       shared by four species templates, so the name comes from #matc's own
       data-species attribute, never a hard-coded string. */
    var bar=document.getElementById('matc'), h1=document.querySelector('.r7-h1'), sp=(bar&&bar.getAttribute('data-species'))||(h1&&h1.textContent.trim())||'Solve Labs';
    if(cap){ var c=cap.textContent.trim(); document.getElementById('matcName').textContent=(c&&c!==sp)?sp+' \u00b7 '+c:sp; }
    var sv=document.querySelector('#optSub .save'), svt=(sv&&!sv.hidden&&sv.textContent.trim())||'';
    document.getElementById('matcSub').textContent=(sub?('Subscribe'+(svt?' \u00b7 '+svt.toLowerCase():'')):'One-time purchase');
    /* a disabled Add (sold-out tier) used to leave the bar's button live and
       silent: add.click() on a disabled button fires nothing */
    var mb=document.getElementById('matcBtn'); if(mb) mb.disabled=!!(add&&add.disabled);
  }
  sync();
  if(add&&'MutationObserver' in window) new MutationObserver(sync).observe(add,{attributes:true,attributeFilter:['disabled']});
  var tgt=document.getElementById('vacta');
  if(tgt&&'MutationObserver' in window) new MutationObserver(sync).observe(tgt,{childList:true,characterData:true,subtree:true});
  document.getElementById('matcBtn').addEventListener('click',function(){ add.click(); });
})();


/* sticky rail — the pin point is measured from the CLOSED rail and never moves.

   This previously recomputed --railtop from the live rail height on every
   resize of the rail, because "accordions change it". A rail taller than the
   viewport gets a NEGATIVE top (bottom-anchored sticky), so the two together
   broke every disclosure on the page: opening "Product details" grew the rail,
   the observer pushed --railtop further negative, and the rail — including the
   heading just clicked — slid UPWARD. The panel appeared to open upwards.

   The offset is now derived from the rail with its panels shut, so content the
   visitor opens expands downward and nothing under the cursor moves. */
/* 5 Oct 2026 — "the right side on all products has to be sticky". With eleven gallery tiles the gallery is now far taller than
   the buy column, and the rule above (a tall rail is not pinned at all) left the column to scroll away and a blank beside the
   lower tiles. Both columns now use the TWO-WAY sticky: each column's `top` follows the scroll, clamped between "its top edge
   under the header" and "its bottom edge at the bottom of the window". So a column taller than the window scrolls with the page
   until its last line is on screen and then holds; scrolling back up brings its top back the same way. Nothing is measured
   "as if closed" any more: a disclosure opened near the foot of the rail grows downward and is reached by scrolling, because the
   clamp is taken from the column's real height at every step. The shorter column is the one that ends up holding. */
(function(){
  var cols=[['.p53-rail','--railtop'],['.p53-gal','--galtop']].map(function(c){
    var el=document.querySelector(c[0]); return el?{el:el,v:c[1],cur:94}:null; }).filter(Boolean);
  if(!cols.length) return;
  var HEAD=94, GAP=24, last=window.scrollY||0;
  var fold=cols[0].el.closest('.p53-fold'); if(fold) fold.classList.remove('rail-tall');
  function step(dy){
    var wide=window.innerWidth>=1081;
    cols.forEach(function(c){
      if(!wide){ c.el.style.removeProperty(c.v); c.cur=HEAD; return; }
      var min=Math.min(HEAD, window.innerHeight-c.el.offsetHeight-GAP);
      c.cur=Math.min(HEAD, Math.max(min, c.cur-dy));
      c.el.style.setProperty(c.v, c.cur+'px');
    });
  }
  function onScroll(){ var y=window.scrollY||0, dy=y-last; last=y; step(dy); }
  step(0);
  addEventListener('scroll',onScroll,{passive:true});
  addEventListener('resize',function(){ step(0); }); addEventListener('load',function(){ step(0); });
})();


/* header controller — the mega menu and mobile sheet shipped without one */
(function(){
  var $=function(id){return document.getElementById(id)};
  var megas=[].slice.call(document.querySelectorAll('.has-mega')), hoverT=null, leaveT=null;
  var desktop=window.matchMedia('(min-width:1001px)'), pinned=null;
  function closeAll(){
    clearTimeout(hoverT); clearTimeout(leaveT); pinned=null;
    megas.forEach(function(li){li.classList.remove('open');
      li.querySelector('.trg').setAttribute('aria-expanded','false');
      li.querySelector('.mega').inert=true;});
  }
  function fitPanel(li){
    var panel=li.querySelector('.mega');
    panel.style.setProperty('--menu-height',Math.max(160,window.innerHeight-panel.getBoundingClientRect().top-16)+'px');
  }
  function openOne(li){if(!desktop.matches)return; closeAll();li.classList.add('open');
    li.querySelector('.trg').setAttribute('aria-expanded','true');
    li.querySelector('.mega').inert=false;fitPanel(li);}
  megas.forEach(function(li){
    var trg=li.querySelector('.trg'), panel=li.querySelector('.mega');
    panel.inert=true;
    li.addEventListener('mouseenter',function(){
      clearTimeout(leaveT);clearTimeout(hoverT);
      if(!desktop.matches||li.classList.contains('open'))return;
      hoverT=setTimeout(function(){openOne(li)},180);
    });
    li.addEventListener('mouseleave',function(){clearTimeout(hoverT);
      if(pinned!==li&&!li.contains(document.activeElement))leaveT=setTimeout(closeAll,320);
    });
    trg.addEventListener('click',function(e){e.preventDefault();clearTimeout(hoverT);
      if(pinned===li){closeAll();return;}
      openOne(li);pinned=li;
    });
    li.addEventListener('keydown',function(e){
      if(e.key==='Escape'){e.preventDefault();closeAll();trg.focus();}
      if(e.target===trg&&e.key==='ArrowDown'){
        e.preventDefault();openOne(li);pinned=li;
        var first=panel.querySelector('button,a[href]');if(first)first.focus();
      }
    });
    li.addEventListener('focusout',function(){setTimeout(function(){
      if(li.classList.contains('open')&&!li.contains(document.activeElement))closeAll();
    },0);});
    li.addEventListener('click',function(e){
      if(e.target.closest('.mm-close')){closeAll();trg.focus();return;}
      var a=e.target.closest('a[href]');if(a&&li.contains(a))closeAll();
    });
  });
  document.addEventListener('click',function(e){if(!e.target.closest('.has-mega'))closeAll();});
  addEventListener('keydown',function(e){if(e.key==='Escape')closeAll();});
  addEventListener('resize',function(){if(!desktop.matches)closeAll();else megas.forEach(function(li){if(li.classList.contains('open'))fitPanel(li);});});
  addEventListener('scroll',function(){megas.forEach(function(li){if(li.classList.contains('open'))fitPanel(li);});},{passive:true});

  /* The mega feature card (MF table) was removed 6 Sep: mega-row.liquid is
     rendered nowhere, its ids exist on no page, and the table hotlinked seven
     product images from the retired prototype host. */

  /* mobile sheet */
  var sheet=$('sheet');
  if(sheet){
    var shClose=function(){sheet.classList.remove('on');$('scrim').classList.remove('on')};
    if($('openMenu')) $('openMenu').onclick=function(){sheet.classList.add('on');$('scrim').classList.add('on')};
    if($('closeMenu')) $('closeMenu').onclick=shClose;
    $('scrim').addEventListener('click',shClose);
    addEventListener('keydown',function(e){if(e.key==='Escape')shClose()});
    if($('shReviews')) $('shReviews').onclick=function(){shClose();location.hash='#reviews'};
    [].forEach.call(sheet.querySelectorAll('.sh > button'),function(b){
      if(b.id==='shReviews')return;
      b.onclick=function(){
        var sh=b.parentNode, was=sh.classList.contains('on');
        [].forEach.call(sheet.querySelectorAll('.sh'),function(x){x.classList.remove('on')});
        if(!was) sh.classList.add('on');
      };
    });
    /* Closing the sheet on ANY link tap hides the very element being tapped
       (visibility:hidden) before the activation completes. Desktop survives
       it; iOS Safari drops the tap, which reads as "the links don't work".
       An in-page jump still needs the sheet out of the way, so close only
       for hash targets - a real navigation unloads the page regardless. */
    [].forEach.call(sheet.querySelectorAll('a'),function(a){
      a.addEventListener('click',function(){
        var h=a.getAttribute('href')||'';
        if(h.charAt(0)==='#') shClose();
      });
    });
  }
})();


/* B4 — delivery estimate computed, never hardcoded */
(function(){
  var el=document.getElementById('deliv58'); if(!el) return;
  var M=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var a=new Date(), b=new Date();
  a.setDate(a.getDate()+3); b.setDate(b.getDate()+7);
  el.textContent=(a.getMonth()===b.getMonth())
    ? a.getDate()+'–'+b.getDate()+' '+M[b.getMonth()]
    : a.getDate()+' '+M[a.getMonth()]+' – '+b.getDate()+' '+M[b.getMonth()];
})();


/* the lab modal. Opens from any [data-lab], which also carries the tab to
   land on, so a "third-party testing" link elsewhere can deep-link to the
   metals tab without new plumbing. */
(function(){
  var lab=document.getElementById('lab'); if(!lab) return;
  var tabs=document.getElementById('labTabs'), last=null;
  function show(name){
    [].forEach.call(tabs.children,function(b){b.classList.toggle('on',b.dataset.t===name)});
    [].forEach.call(lab.querySelectorAll('.lab-pane'),function(s){
      s.classList.toggle('on',s.dataset.p===name)});
    lab.querySelector('.lab-body').scrollTop=0;
  }
  function open(name){
    last=document.activeElement;
    lab.classList.add('on'); lab.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
    show(name||'glucans');
    requestAnimationFrame(function(){lab.classList.add('in')});
    var x=lab.querySelector('.lab-x'); if(x) x.focus();
  }
  function close(){
    lab.classList.remove('in'); lab.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
    setTimeout(function(){lab.classList.remove('on')},280);
    if(last&&last.focus) last.focus();
  }
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-lab]');
    if(t){e.preventDefault(); open(t.dataset.lab); return;}
    if(e.target.closest('[data-close]')){e.preventDefault(); close();}
  });
  tabs.addEventListener('click',function(e){
    var b=e.target.closest('button'); if(b) show(b.dataset.t);
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&lab.classList.contains('on')) close();
  });
  /* sample selector — visual only; updates the honest caption, never the results.
     Testing is periodic and relates to the tested sample regardless of format. */
  var sample=document.getElementById('labSample'), note=document.getElementById('labSampleNote');
  if(sample&&note){
    sample.addEventListener('change',function(){
      var v=sample.options[sample.selectedIndex].text;
      note.innerHTML='Showing '+v+' &mdash; safety lot GS241117; results relate to the tested sample.';
    });
  }
})();


/* audit modal — its own controller so it never collides with the lab modal's
   [data-lab]/[data-close] plumbing. Opens on [data-audit], closes on
   [data-audit-close] or Escape. */
(function(){
  var m=document.getElementById('audit'); if(!m) return;
  var last=null;
  function open(){
    last=document.activeElement;
    m.classList.add('on'); m.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
    var s=m.querySelector('.lab-scroll'); if(s) s.scrollTop=0;
    requestAnimationFrame(function(){m.classList.add('in')});
    var x=m.querySelector('.lab-x'); if(x) x.focus();
  }
  function close(){
    m.classList.remove('in'); m.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
    setTimeout(function(){m.classList.remove('on')},280);
    if(last&&last.focus) last.focus();
  }
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-audit]')){e.preventDefault(); open(); return;}
    if(e.target.closest('[data-audit-close]')){e.preventDefault(); close();}
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&m.classList.contains('on')) close();
  });
})();


(function(){
  var plans=document.querySelectorAll('.p52-plan');
  function paint(b){
    var atc=document.getElementById('p52px');
    if(!atc) return;
    atc.textContent='£'+parseFloat(b.dataset.sub).toFixed(2);
    var was=document.querySelector('.p52-atc s');
    if(was) was.textContent='£'+parseFloat(b.dataset.one).toFixed(2);
  }
  /* paint on load too — the 90-day plan is pre-selected, so without this
     the button showed whatever was hardcoded in the markup */
  var pre=document.querySelector('.p52-plan.on'); if(pre) paint(pre);
  plans.forEach(function(b){b.addEventListener('click',function(){
    plans.forEach(function(x){x.classList.toggle('on',x===b)});
    var atc=document.getElementById('p52px');
    if(atc){atc.textContent='£'+parseFloat(b.dataset.sub).toFixed(2);
      var was=document.querySelector('.p52-atc s');
      if(was) was.textContent='£'+parseFloat(b.dataset.one).toFixed(2);}
  })});
  document.querySelectorAll('.p52-acc .ac>button').forEach(function(b){
    b.addEventListener('click',function(){b.parentElement.classList.toggle('on')});
  });
})();


(function(){
  /* the ritual accordion and the FAQ, one open at a time within each */
  function acc(sel, cls){
    [].forEach.call(document.querySelectorAll(sel+' button'),function(b){
      b.onclick=function(){
        var row=b.parentNode, open=row.classList.contains('on');
        [].forEach.call(document.querySelectorAll(sel),function(x){x.classList.remove('on')});
        if(!open) row.classList.add('on');
      };
    });
  }
  acc('.wa'); acc('.f1');
})();


(function(){
  var cards=document.querySelectorAll('.people .pcard');
  cards.forEach(function(c){
    var b=c.querySelector('.flipbtn'); if(!b) return;
    b.addEventListener('click',function(e){ e.stopPropagation(); c.classList.toggle('flipped'); });
  });
})();


(function(){
  var m=document.getElementById('g60'); if(!m) return;
  var last=null;
  function open(){ last=document.activeElement; m.classList.add('on'); m.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden'; var x=m.querySelector('.g60-x'); if(x) x.focus(); }
  function close(){ m.classList.remove('on'); m.setAttribute('aria-hidden','true');
    document.body.style.overflow=''; if(last&&last.focus) last.focus(); }
  document.addEventListener('click',function(e){
    var o=e.target.closest('[data-g60]');
    if(o){ e.preventDefault(); open(); return; }
    var c=e.target.closest('[data-g60c]');
    if(c && m.classList.contains('on')){ close(); }
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape' && m.classList.contains('on')) close();
  });
})();


/* 58c13 · buy-box engine.

   Capsules, powder and drops are THREE SEPARATE PRODUCTS with their own SKUs and
   their own URLs. The format selector therefore NAVIGATES between them rather
   than swapping the buy box in place — otherwise a powder buyer would sit on the
   capsules URL, which breaks canonical URLs, analytics and sharing.

   Everything below describes only the product actually being viewed: its own
   variants become the supply tiles, its own prices and selling plans drive the
   buy box. Nothing about money is hard-coded. */
(function(){
  var $=function(id){return document.getElementById(id)};
  var el=$('pdp-formats'); if(!el) return;
  var DATA={}; try{ DATA=JSON.parse(el.textContent); }catch(e){ return; }
  var EU_DROPS='https://solvelabs.eu/grzyby/116-soplowka-jezowata-lion-s-mane-w-kroplach-60ml.html';

  var IMG=null;
  try{ var gEl=$('pdp-gallery'); if(gEl) IMG=JSON.parse(gEl.textContent); }catch(e){}
  IMG=IMG||{};

  var CUR=DATA.current||'caps';
  var FMT=DATA.formats||{};
  /* Every tier is shown even when it is out of stock, so the ladder reads the
     same on every product (Reishi's 3-month powder is sold out, and hiding it
     left a 6/9/bundle ladder that looked broken). Availability is expressed on
     the Add button and a sold-out note, not by removing the option. */
  var TIERS=(DATA.tiers||[]).slice();
  /* The supply ladder is consistent across the range: capsules and liquid run
     1 / 2 / 4 months + a bundle, powder runs 3 / 6 / 9 + a bundle. Powders still
     carry a legacy 30 g one-month SKU; it is hidden here rather than deleted, so
     the ladder reads consistently without destroying a variant that may have
     order history. */
  /* 🛑 The gate is the presence of a 3-Month tier, NOT the format slot. The
     gummies template repurposes the three format slots as Focus/Calm/Kids, so
     the Calm page reports CUR==='powder' and this filter was deleting its £29
     entry tier outright; Mushroom Complex Powder (a real 1/2/4 ladder) lost its
     £55 tier the same way. Only the species powders run 3/6/9, and only they
     carry the legacy 30 g one-month SKU this is meant to hide. */
  var hasThreeMonth=(DATA.tiers||[]).some(function(v){ return /^3\s*Months/i.test(v.title||''); });
  /* 10 Oct 2026, his word on the Lion's Mane powder page ("we also have 1 month here, 30 g... we should have 1 month, 3 months,
     6 months"): where the 30 g pouch leads the page, the row is 1 Month / 3 Months / 6 Months and the four-jar size leaves it
     (kept in Shopify: it has subscribers and order history). The other species powders keep the old row until their pouch
     photographs are in the theme: their lead picture is still the 100 g jar, and a jar beside the 30 g price is the mistake
     of 8 Oct. Add a handle here when its pouch picture leads its gallery. */
  var POUCH_LEADS=['lions-mane-powder'];
  var pouchLeads=POUCH_LEADS.indexOf(decodeURIComponent((/\/products\/([^\/?#]+)/.exec(location.pathname)||[])[1]||''))>-1;
  if(CUR==='powder' && hasThreeMonth) TIERS=TIERS.filter(function(v){ return pouchLeads ? !/^300\s*g/i.test(v.title||'') : !/^1\s*Month/i.test(v.title||''); });
  if(!TIERS.length) TIERS=(DATA.tiers||[]).slice(0,1);
  /* Supply ladder order: durations smallest-first (Shopify returns variants in
     admin order, which put the 100 g powder ahead of the 30 g), and any bundle
     or plan last — a bundle is a different kind of offer, not a bigger size. */
  var isBundle=function(v){ return /\b(bundle|plan|set)\b/i.test(v.title||''); };
  /* ── the named bundle for this product ──────────────────────────────────
     The same set the quiz recommends and the foot of the page sells, as the
     fourth tile in the size row. */
  /* 🛑 Products whose ONLY Shopify photography is a lifestyle shot — coloured
     backdrop, hand in frame. Every other product leads with a transparent PNG or
     a packshot on white, which floats cleanly under `mix-blend-mode:multiply`.
     These render as coloured rectangles bleeding out of the tile instead.
     ▶ Give the gummies real packshots and this list empties. */
  var LIFESTYLE_ONLY=["focus-gummies", "kids-mushroom-gummies", "sleep-mushroom-gummies"];
  var BND=null; try{ BND=JSON.parse(document.getElementById('pdp-bundle').textContent); }catch(e){}
  if(BND && (!BND.items || BND.items.length<BND.min)) BND=null;
  /* ── THE SET'S OWN GALLERY (7 Oct 2026: "these gallery is on the product level NOT on the bundle level. when i click bundle in for
     example brain tech then the gallery per this variation changes").
     Each of the fifteen sets has seven pictures (white pack shot, shelf, what is in it, the three at home, your day, one product in
     use, the offer). Picking the set tile swaps the product's gallery for the set's; picking a size puts the product's back.
     🛑 Only when the three products in the set on THIS page are the three in the pictures: a set resolves per page (the powder
     page holds the powders, a sold-out jar is substituted), and pictures of other products would be a lie. Each set therefore
     lists its versions (capsules, powders, drops, the second coffee); where none matches, the product's own gallery stays.
     The block between the markers is written by _pdp/photo/bundles/v2/build.py from manifest.json: do not edit it by hand. */
  /* SETGAL:begin */
  var SETGAL={"deep-work":[{"h":"brain-tech,lions-mane-capsules,reishi-10-1-extract-capsules","f":["set-deep-work-0-white.jpg","set-deep-work-1-main.jpg","set-deep-work-2-inside.jpg","set-deep-work-3-desk.jpg","set-deep-work-4-day.jpg","set-deep-work-5-evening.jpg","set-deep-work-6-deal.jpg"],"a":"A hand sets Reishi capsules down on a side table in the evening, beside a cup of tea and a book"},{"h":"brain-tech,lions-mane-powder,reishi","f":["set-deep-work-powder-0-white.jpg","set-deep-work-powder-1-main.jpg","set-deep-work-powder-2-inside.jpg","set-deep-work-powder-3-together.jpg","set-deep-work-powder-4-day.jpg","set-deep-work-powder-5-evening.jpg","set-deep-work-powder-6-deal.jpg"],"a":"A scoop of Reishi powder going into a mug of herbal tea in the evening, the pouch beside it"},{"h":"brain-tech,lions-mane-drops,reishi-drops","f":["set-deep-work-drops-0-white.jpg","set-deep-work-drops-1-main.jpg","set-deep-work-drops-2-inside.jpg","set-deep-work-drops-3-together.jpg","set-deep-work-drops-4-day.jpg","set-deep-work-drops-5-morning.jpg","set-deep-work-drops-6-deal.jpg"],"a":"A dropper of Lion’s Mane held over a mug of coffee, the open bottle beside it"}],"desk-day":[{"h":"brain-tech,mushroom-matcha,sleep-mushroom-gummies","f":["set-desk-day-0-white.jpg","set-desk-day-1-main.jpg","set-desk-day-2-inside.jpg","set-desk-day-3-desk.jpg","set-desk-day-4-day.jpg","set-desk-day-5-evening.jpg","set-desk-day-6-deal.jpg"],"a":"Two Calm Reishi Gummies in the hand at a bedside table in the evening, beside a glass of water"}],"three-oclock":[{"h":"complete-b-complex,cordyceps,mushroom-yerba-mate","f":["set-three-oclock-0-white.jpg","set-three-oclock-1-main.jpg","set-three-oclock-2-inside.jpg","set-three-oclock-3-desk.jpg","set-three-oclock-4-day.jpg","set-three-oclock-5-kitchen.jpg","set-three-oclock-6-deal.jpg"],"a":"A spoon of Mushroom Yerba Mate going into a glass of iced water on a kitchen counter"}],"no-coffee":[{"h":"complete-b-complex,cordyceps,electrolytes","f":["set-no-coffee-0-white.jpg","set-no-coffee-1-main.jpg","set-no-coffee-2-inside.jpg","set-no-coffee-3-together.jpg","set-no-coffee-4-day.jpg","set-no-coffee-5-kitchen.jpg","set-no-coffee-6-deal.jpg"],"a":"A scoop of Electrolyte Balance going into a bottle of water on a kitchen worktop"}],"last-hour":[{"h":"chaga,mushroom-cacao,reishi-10-1-extract-capsules","f":["set-last-hour-0-white.jpg","set-last-hour-1-main.jpg","set-last-hour-2-inside.jpg","set-last-hour-3-together.jpg","set-last-hour-4-day.jpg","set-last-hour-5-evening.jpg","set-last-hour-6-deal.jpg"],"a":"A hand stirring a mug of Mushroom Cacao in the evening, the pouch beside it"},{"h":"chaga-inonotus-obliquus-10-1-extract-powder,mushroom-cacao,reishi","f":["set-last-hour-powder-0-white.jpg","set-last-hour-powder-1-main.jpg","set-last-hour-powder-2-inside.jpg","set-last-hour-powder-3-together.jpg","set-last-hour-powder-4-day.jpg","set-last-hour-5-evening.jpg","set-last-hour-powder-6-deal.jpg"],"a":"A hand stirring a mug of Mushroom Cacao in the evening, the pouch beside it"},{"h":"chaga-drops,mushroom-cacao,reishi-drops","f":["set-last-hour-drops-0-white.jpg","set-last-hour-drops-1-main.jpg","set-last-hour-drops-2-inside.jpg","set-last-hour-drops-3-together.jpg","set-last-hour-drops-4-day.jpg","set-last-hour-5-evening.jpg","set-last-hour-drops-6-deal.jpg"],"a":"A hand stirring a mug of Mushroom Cacao in the evening, the pouch beside it"}],"training-block":[{"h":"creatine-plus,electrolytes,shroom-foce","f":["set-training-block-0-white.jpg","set-training-block-1-main.jpg","set-training-block-2-inside.jpg","set-training-block-3-together.jpg","set-training-block-4-day.jpg","set-training-block-5-kitchen.jpg","set-training-block-6-deal.jpg"],"a":"A scoop of Creatine+ held over a shaker of water, the open tub beside it"}],"engine-room":[{"h":"cordyceps,creatine-plus,vegan-protein","f":["set-engine-room-0-white.jpg","set-engine-room-1-main.jpg","set-engine-room-2-inside.jpg","set-engine-room-3-together.jpg","set-engine-room-4-day.jpg","set-engine-room-5-kitchen.jpg","set-engine-room-6-deal.jpg"],"a":"A hand holding a shaker of plant-based protein, the pouch behind it"},{"h":"creatine-plus,high-strength-cordyceps-powder,vegan-protein","f":["set-engine-room-powder-0-white.jpg","set-engine-room-powder-1-main.jpg","set-engine-room-powder-2-inside.jpg","set-engine-room-powder-3-together.jpg","set-engine-room-powder-4-day.jpg","set-engine-room-5-kitchen.jpg","set-engine-room-powder-6-deal.jpg"],"a":"A hand holding a shaker of plant-based protein, the pouch behind it"},{"h":"cordyceps-drops,creatine-plus,vegan-protein","f":["set-engine-room-drops-0-white.jpg","set-engine-room-drops-1-main.jpg","set-engine-room-drops-2-inside.jpg","set-engine-room-drops-3-together.jpg","set-engine-room-drops-4-day.jpg","set-engine-room-5-kitchen.jpg","set-engine-room-drops-6-deal.jpg"],"a":"A hand holding a shaker of plant-based protein, the pouch behind it"}],"morning-swap":[{"h":"complete-green-superfoods,mushroom-coffee,vitamin-d2-shiitake","f":["set-morning-swap-0-white.jpg","set-morning-swap-1-main.jpg","set-morning-swap-2-inside.jpg","set-morning-swap-3-together.jpg","set-morning-swap-4-day.jpg","set-morning-swap-5-kitchen.jpg","set-morning-swap-6-deal.jpg"],"a":"Hot water poured over Mushroom Coffee in a pour-over, the bag beside it"},{"h":"complete-green-superfoods,copy-of-mushroom-coffee-chaga-ashwaghanda,vitamin-d2-shiitake","f":["set-morning-swap-chaga-0-white.jpg","set-morning-swap-chaga-1-main.jpg","set-morning-swap-chaga-2-inside.jpg","set-morning-swap-chaga-3-together.jpg","set-morning-swap-chaga-4-day.jpg","set-morning-swap-chaga-5-kitchen.jpg","set-morning-swap-chaga-6-deal.jpg"],"a":"Hot water poured over Mushroom Coffee in a pour-over, the bag beside it"}],"first-month":[{"h":"lions-mane-capsules,mushroom-cacao,vitamin-d2-shiitake","f":["set-first-month-0-white.jpg","set-first-month-1-main.jpg","set-first-month-2-inside.jpg","set-first-month-3-together.jpg","set-first-month-4-day.jpg","set-first-month-5-morning.jpg","set-first-month-6-deal.jpg"],"a":"Two Lion’s Mane capsules in an open palm at the breakfast table, the jar in the other hand"}],"nothing-to-swallow":[{"h":"complete-green-superfoods,focus-gummies,sleep-mushroom-gummies","f":["set-nothing-to-swallow-0-white.jpg","set-nothing-to-swallow-1-main.jpg","set-nothing-to-swallow-2-inside.jpg","set-nothing-to-swallow-3-together.jpg","set-nothing-to-swallow-4-day.jpg","set-nothing-to-swallow-5-desk.jpg","set-nothing-to-swallow-6-deal.jpg"],"a":"Two Focus Gummies in an open palm at a desk, the jar in the other hand"}],"family-shelf":[{"h":"kids-mushroom-gummies,lions-mane-capsules,vitamin-d2-shiitake","f":["set-family-shelf-0-white.jpg","set-family-shelf-1-main.jpg","set-family-shelf-2-inside.jpg","set-family-shelf-3-together.jpg","set-family-shelf-4-day.jpg","set-family-shelf-5-morning.jpg","set-family-shelf-6-deal.jpg"],"a":"The jar of Kids Gummies on a kitchen worktop beside a lunchbox, a backpack and a bowl of apples"}],"everyday-baseline":[{"h":"complete-green-superfoods,mushroom-complex-capsules,vitamin-d2-shiitake","f":["set-everyday-baseline-0-white.jpg","set-everyday-baseline-1-main.jpg","set-everyday-baseline-2-inside.jpg","set-everyday-baseline-3-together.jpg","set-everyday-baseline-4-day.jpg","set-everyday-baseline-5-kitchen.jpg","set-everyday-baseline-6-deal.jpg"],"a":"A hand stirring a glass of Green Superfoods, the pouch beside it"},{"h":"complete-green-superfoods,mushroom-complex-powder,vitamin-d2-shiitake","f":["set-everyday-baseline-powder-0-white.jpg","set-everyday-baseline-powder-1-main.jpg","set-everyday-baseline-powder-2-inside.jpg","set-everyday-baseline-powder-3-together.jpg","set-everyday-baseline-powder-4-day.jpg","set-everyday-baseline-5-kitchen.jpg","set-everyday-baseline-powder-6-deal.jpg"],"a":"A hand stirring a glass of Green Superfoods, the pouch beside it"},{"h":"complete-green-superfoods,mushroom-complex-drops,vitamin-d2-shiitake","f":["set-everyday-baseline-drops-0-white.jpg","set-everyday-baseline-drops-1-main.jpg","set-everyday-baseline-drops-2-inside.jpg","set-everyday-baseline-drops-3-together.jpg","set-everyday-baseline-drops-4-day.jpg","set-everyday-baseline-5-kitchen.jpg","set-everyday-baseline-drops-6-deal.jpg"],"a":"A hand stirring a glass of Green Superfoods, the pouch beside it"}],"long-game":[{"h":"chaga,collagen,tremella-capsules","f":["set-long-game-0-white.jpg","set-long-game-1-main.jpg","set-long-game-2-inside.jpg","set-long-game-3-together.jpg","set-long-game-4-day.jpg","set-long-game-5-morning.jpg","set-long-game-6-deal.jpg"],"a":"A scoop of collagen going into a mug of coffee, the open tub beside it"},{"h":"chaga-inonotus-obliquus-10-1-extract-powder,collagen,tremella-powder","f":["set-long-game-powder-0-white.jpg","set-long-game-powder-1-main.jpg","set-long-game-powder-2-inside.jpg","set-long-game-powder-3-together.jpg","set-long-game-powder-4-day.jpg","set-long-game-5-morning.jpg","set-long-game-powder-6-deal.jpg"],"a":"A scoop of collagen going into a mug of coffee, the open tub beside it"},{"h":"chaga-drops,collagen,tremella-capsules","f":["set-long-game-drops-0-white.jpg","set-long-game-drops-1-main.jpg","set-long-game-drops-2-inside.jpg","set-long-game-drops-3-together.jpg","set-long-game-drops-4-day.jpg","set-long-game-5-morning.jpg","set-long-game-drops-6-deal.jpg"],"a":"A scoop of collagen going into a mug of coffee, the open tub beside it"}],"underrated":[{"h":"auricularia-powder,chaga,maitake-capsules","f":["set-underrated-0-white.jpg","set-underrated-1-main.jpg","set-underrated-2-inside.jpg","set-underrated-3-together.jpg","set-underrated-4-day.jpg","set-underrated-5-kitchen.jpg","set-underrated-6-deal.jpg"],"a":"A scoop of Auricularia powder held over a cup of tea, the open tub beside it"},{"h":"auricularia-powder,chaga-inonotus-obliquus-10-1-extract-powder,maitake-powder","f":["set-underrated-powder-0-white.jpg","set-underrated-powder-1-main.jpg","set-underrated-powder-2-inside.jpg","set-underrated-powder-3-together.jpg","set-underrated-powder-4-day.jpg","set-underrated-5-kitchen.jpg","set-underrated-powder-6-deal.jpg"],"a":"A scoop of Auricularia powder held over a cup of tea, the open tub beside it"}],"no-single-hour":[{"h":"complete-green-superfoods,mushroom-complex-capsules,shilajit-complex","f":["set-no-single-hour-0-white.jpg","set-no-single-hour-1-main.jpg","set-no-single-hour-2-inside.jpg","set-no-single-hour-3-together.jpg","set-no-single-hour-4-day.jpg","set-no-single-hour-5-morning.jpg","set-no-single-hour-6-deal.jpg"],"a":"Two Shilajit Complex softgels in an open palm at the breakfast table, the jar in the other hand"}]};
  /* SETGAL:end */
  var SETV='20261008a';
  var ABASE=(function(){ var sc=document.querySelector('script[src*="pdp58c13"]'), m=sc&&/^(.*\/assets\/)/.exec(sc.getAttribute('src')||''); return m?m[1]:''; })();
  /* ── TWO PACKS, FIVE PACKS (7 Oct 2026: "when you have two months we will have two products next to each other… 4 plus 1 month
     we will have 5 products on the image"). A size that ships two packs shows two, "4 + 1 Free" shows five: on its tile, and as
     the first gallery picture while it is picked. The pictures are the real pack cut-out repeated (_pdp/photo/packs/packs.py,
     which also writes the list between the markers): packs-<handle>-<n>.jpg for the gallery, -<n>t.webp for the tile. */
  /* PACKS:begin */
  var PACKS={"auricularia-powder":{"200 g":"2","300 g + 100 g Free":"4"},"brain-tech":{"2 Months":"2","4 + 1 Free":"5"},"chaga":{"2 Months":"2","4 + 1 Free":"5"},"chaga-drops":{"2 Months":"2","4 + 1 Free":"5"},"chaga-inonotus-obliquus-10-1-extract-powder":{"6 Months":"2","300 g + 100 g Free":"4","3 Months":"~1"},"collagen":{"2 Months":"2","4 + 1 Free":"5"},"complete-b-complex":{"4 Months":"2","4 + 1 Free":"5"},"complete-green-superfoods":{"2 Packs":"2","4 + 1 Free":"5"},"copy-of-mushroom-coffee-chaga-ashwaghanda":{"2 Pack":"2","4 + 1 Free":"5","2 Pack (Mixed)":"mix"},"cordyceps":{"2 Months":"2","4 + 1 Free":"5"},"cordyceps-drops":{"2 Months":"2","4 + 1 Free":"5"},"creatine-plus":{"2 Months":"2","4 + 1 Free":"5"},"electrolytes":{"2 Pack":"2","4 + 1 Free":"5"},"focus-gummies":{"2 Months":"2","4 + 1 Free":"5"},"high-strength-cordyceps-powder":{"6 Months":"2","300 g + 100 g Free":"4","3 Months":"~1"},"kids-mushroom-gummies":{"2 Months":"2","4 + 1 Free":"5"},"lions-mane-capsules":{"2 Months":"2","4 + 1 Free":"5"},"lions-mane-drops":{"2 Months":"2","4 + 1 Free":"5"},"lions-mane-powder":{"6 Months":"2","300 g + 100 g Free":"4","3 Months":"tub"},"maitake-capsules":{"2 Months":"2","4 + 1 Free":"5"},"maitake-powder":{"200 g":"2","300 g + 100 g Free":"4"},"mushroom-coffee":{"2 Pack":"2","4 + 1 Free":"5","2 Pack (Mixed)":"mix"},"mushroom-complex-capsules":{"2 Months":"2","4 + 1 Free":"5"},"mushroom-complex-drops":{"2 Months":"2","4 + 1 Free":"5"},"mushroom-complex-powder":{"2 Months":"2","4 + 1 Free":"5"},"mushroom-yerba-mate":{"2 Months":"2","4 + 1 Free":"5"},"reishi":{"6 Months":"2","300 g + 100 g Free":"4","3 Months":"~1"},"reishi-10-1-extract-capsules":{"2 Months":"2","4 + 1 Free":"5"},"reishi-drops":{"2 Months":"2","4 + 1 Free":"5"},"shilajit-complex":{"2 Months":"2","4 + 1 Free":"5"},"shroom-foce":{"2 Pack":"2","4 + 1 Free":"5"},"sleep-mushroom-gummies":{"2 Months":"2","4 + 1 Free":"5"},"tremella-capsules":{"2 Months":"2","4 + 1 Free":"5"},"vegan-protein":{"Salted Caramel":"~caramel","Mixed (2pack)":"mix","Mixed (4pack)":"mix4"},"vitamin-d2-shiitake":{"4 Months":"2","4 + 1 Free":"5"}};
  /* PACKS:end */
  var HANDLE=(function(){ var m=/\/products\/([^\/?#]+)/.exec(location.pathname); return m?decodeURIComponent(m[1]):''; })();
  /* PACKS = {handle: {size title: key}} (written by packs.py). A key that starts with ~ is the tile's picture only: the gallery
     already shows that pack (the Salted Caramel pouch, a powder's 100 g tub). Powders and mixed packs were added the same day:
     two and four tubs, one bag of each coffee, the two protein flavours. */
  function packKey(z){ var m=ABASE&&PACKS[HANDLE]; return (m&&z&&m[z.title])||''; }
  function packN(z){ var k=packKey(z); return (!k||k.charAt(0)==='~')?1:(k==='mix'?2:k==='mix4'?4:Number(k)||1); }
  function packSrc(k,tile){ return ABASE+'packs-'+HANDLE+'-'+String(k).replace('~','')+(tile?'t.webp':'.jpg')+'?v='+SETV; }
  function setGal(){
    if(!BND) return null;
    if(BND._gal!==undefined) return BND._gal;
    /* a set has one gallery per version (capsules, powders, drops…): the one whose three products are the three on this page */
    var mine=BND.items.map(function(x){ return x.h; }).sort().join(','), d=null, g=null;
    (SETGAL[BND.id]||[]).forEach(function(v){ if(v.h===mine) d=v; });
    if(d){
      var m=ABASE?[0,ABASE]:null;
      if(m){
        var lang=(document.documentElement.getAttribute('lang')||'').slice(0,2), pre=(lang==='es'||lang==='de')?lang+'--':'';
        var names=BND.items.map(function(x){ return x.t; }), three=names.slice(0,-1).join(', ')+' + '+names[names.length-1];
        var alts=[BND.n+': '+three, 'The three on a shelf: '+three, 'What is in the set: '+three, 'The three at home: '+three,
                  'Your day: when to take each of the three', d.a,
                  'Three together: 15% off with the code BUNDLE15, free UK delivery over £50, 60 days to decide'];
        /* the three typeset pictures (what is in it, your day, the offer) exist in Spanish and German */
        g={cap:BND.n, alts:alts, shots:d.f.map(function(f,i){ return m[1]+((i===2||i===4||i===6)?pre:'')+f+'?v='+SETV; })};
      }
    }
    BND._gal=g; return g;
  }
  /* the gallery on screen: the set's while its tile is picked and it has one, else the product's */
  function galNow(){
    var set=state.bundle&&setGal(); if(set) return set;
    var g=IMG[CUR]||IMG.caps||{shots:[],alts:[]}, n=state.bundle?1:packN(tier()), pk0=state.bundle?'':packKey(tier());
    if(pk0&&pk0.charAt(0)!=='~'&&g.shots&&g.shots.length){   /* the pack shot becomes two packs, or five; or (8 Oct 2026, Lion's Mane powder,
                                                                key 'tub') the 100 g tub while "3 Months" is picked: the pouch leads */
      var c={}; for(var k in g) c[k]=g[k];
      c.shots=g.shots.slice(); c.alts=(g.alts||[]).slice(); c.shots[0]=packSrc(pk0); var a0=g.tub||c.alts[0]||document.title; c.alts[0]=n>1?a0+' \u00d7 '+n:a0;   /* g.tub: the 100 g jar's own description, where the lead picture is the pouch */
      return c;
    }
    return g;
  }
  /* 🛑 The legacy 4th variants — "Focus Plan", "Athlete Plan", "Skin Bundle",
     "Gummy Set" — are the half-built first attempt at this idea. They are
     variants of ONE product, so they cannot hold a second product, and some are
     broken outright: Cordyceps Powder sells the SAME SKU as "3 Months" (£55)
     and as "Athlete Plan" (£100). Hidden here, not deleted: a variant with
     order history is not safe to remove from the theme. */
  if(BND){
    var real=TIERS.filter(function(v){ return !isBundle(v); });
    if(real.length) TIERS=real;
  }
  TIERS.sort(function(a,b){
    var ab=isBundle(a)?1:0, bb=isBundle(b)?1:0;
    if(ab!==bb) return ab-bb;
    return (a.one||0)-(b.one||0);
  });

  var money=function(c){ return window.SolveMoney(c/100); };

  /* ── delivery frequency ────────────────────────────────────────────────
     PLANS[variantId] = [{id, price, label}] — every selling plan the variant
     offers, not just the first one the template happened to emit. */
  var PLANS={}, PLAN_LABEL={};

  /* 🛑 An option value is supposed to be a human word — "month", "2 months".
     One rule on this store has raw JSON in it instead:
       {"delivery":{"interval":"MONTH","frequency":6},"billing":{...}}
     printed verbatim into the dropdown and the price line. Never trust the
     field: if it parses as JSON, read the cadence out of it; if it is a word,
     use the word; if it is neither, fall back to the plan's name. */
  function readEvery(v, fallback){
    if(v==null) return fallback||'';
    var s=String(v).trim();
    if(s.charAt(0)==='{'){
      try{
        var d=JSON.parse(s).delivery||{};
        var n=Number(d.frequency)||1, u=String(d.interval||'month').toLowerCase();
        return n===1 ? u : (n+' '+u+'s');
      }catch(e){ return fallback||''; }
    }
    return s;
  }
  function planFor(z){
    var list=PLANS[z.variant]; if(!list||!list.length) return null;
    for(var i=0;i<list.length;i++){ if(list[i].id===state.planId) return list[i]; }
    return list[0];
  }
  (function loadPlans(){
    var u=(DATA.formats&&DATA.formats[CUR]&&DATA.formats[CUR].url)||location.pathname;
    fetch(u.split('?')[0]+'.js',{headers:{'Accept':'application/json'}})
      .then(function(r){ return r.ok? r.json() : null; })
      .then(function(p){
        if(!p) return;
        /* the group's option values are the human words for each cadence —
           "month", "2 months" — and they are what the dropdown should say */
        (p.selling_plan_groups||[]).forEach(function(g){
          (g.selling_plans||[]).forEach(function(s){
            var o=(s.options||[])[0];
            PLAN_LABEL[s.id]= readEvery(o && o.value, s.name);
          });
        });
        (p.variants||[]).forEach(function(v){
          PLANS[v.id]=(v.selling_plan_allocations||[]).map(function(a){
            return {id:a.selling_plan_id, price:a.per_delivery_price,
                    every:PLAN_LABEL[a.selling_plan_id]||''};
          });
        });
        render();
      }).catch(function(){});
  })();

  /* The cadence this TIER is delivered on, in the subscription app's own words. */
  function cadence(z){
    var pl=planFor(z);
    if(!pl || !pl.every) return '/mo';
    var e=pl.every.toLowerCase();
    return (e==='month' || e==='1 month') ? '/mo' : ('every ' + e);
  }

  /* ── the frequency dropdown ─────────────────────────────────────────────
     Deliver every 1 / 2 / 4 months. The options are the plans the subscription
     app actually offers on THIS variant — never invented, because the value is
     a selling_plan id that gets charged. A fabricated option would take money
     on the wrong cadence. */
  function paintFreq(z){
    var list=PLANS[z.variant]||[], host=$('vaseg'), sel=$('c9every'), lab=$('c9everyl');
    if(!host || list.length<2 || state.plan!=='sub'){
      if(sel) sel.remove(); if(lab) lab.remove(); return;
    }
    if(!sel){
      lab=document.createElement('span'); lab.id='c9everyl'; lab.className='c9-everyl';
      lab.textContent='Deliver every';
      sel=document.createElement('select'); sel.id='c9every'; sel.className='c9-every';
      sel.setAttribute('aria-label','Delivery frequency');
      host.parentNode.insertBefore(lab, host.nextSibling);
      host.parentNode.insertBefore(sel, lab.nextSibling);
      sel.addEventListener('change',function(){ state.planId=Number(sel.value); render(); });
    }
    var cur=(planFor(z)||{}).id;
    sel.innerHTML=list.map(function(p){
      var every=p.every||'month';
      return '<option value="'+p.id+'"'+(p.id===cur?' selected':'')+'>'+
             every.charAt(0).toUpperCase()+every.slice(1)+
             ' · '+money(p.price)+'</option>'; }).join('');
  }

  /* 'p' is pence — only legal when the presentment currency IS sterling. */
  var GBP=((DATA.shop||{}).currency==='GBP');
  var pserv=function(cents,srv){ var p=Math.round(cents/srv);
    return (GBP && p<100) ? (p+'p') : money(p); };
  var firstBuyable=TIERS.filter(function(v){return v.available!==false;})[0]||TIERS[0]||{};
  /* ads and Shopping links arrive with ?variant=; honour it */
  var qv=Number((location.search.match(/[?&]variant=(\d+)/)||[])[1]);
  var deep=TIERS.filter(function(v){ return v.variant===qv; })[0];
  var state={k:(deep||firstBuyable).variant, plan:'sub', qty:1};

  /* Picking a sold-out tier must not be a dead end. Name the closest tier that
     can actually ship and hand it over in one click, rather than leaving a
     disabled button and a hunt back up the row. Closeness is measured on PRICE,
     so the offer is the nearest SIZE and not merely the first tile in the row;
     a bundle is a different kind of offer, so it is the fallback, never first. */
  function nearestInStock(z){
    var ok=function(v){ return v.variant && v.variant!==z.variant && v.available!==false; };
    var pool=TIERS.filter(function(v){ return ok(v) && !isBundle(v); });
    if(!pool.length) pool=TIERS.filter(ok);
    if(!pool.length) return null;
    return pool.slice().sort(function(a,b){
      return Math.abs((a.one||0)-(z.one||0)) - Math.abs((b.one||0)-(z.one||0)); })[0];
  }

  function tier(){
    for(var i=0;i<TIERS.length;i++){ if(TIERS[i].variant===state.k) return TIERS[i]; }
    return TIERS[0]||{};
  }

  /* ── switching format must not move the page ──
     The three formats are separate PRODUCTS, so the row navigates rather than
     swapping the buy box in place — and an ordinary navigation lands you at the
     top of the new page, which loses your place halfway down a long PDP.
     Record where the row sits in the viewport before leaving, then put it back
     in exactly that spot on arrival. Anchoring to the ROW rather than to a raw
     scroll offset matters: the sibling pages are not identical heights. */
  var FMT_ANCHOR='solve-fmt-anchor';
  function fmtRemember(){
    var r=$('c9fmt'); if(!r) return;
    try{ sessionStorage.setItem(FMT_ANCHOR, String(Math.round(r.getBoundingClientRect().top))); }catch(e){}
  }
  (function fmtRestore(){
    var raw=null; try{ raw=sessionStorage.getItem(FMT_ANCHOR); }catch(e){}
    if(raw===null) return;
    /* only THIS load takes over scrolling — leaving it on for every PDP
       load broke Back from the basket (landed at the top) */
    try{ if('scrollRestoration' in history) history.scrollRestoration='manual'; }catch(e){}
    try{ sessionStorage.removeItem(FMT_ANCHOR); }catch(e){}
    var want=parseInt(raw,10); if(isNaN(want)) return;
    var put=function(){
      var r=$('c9fmt'); if(!r) return;
      var d=r.getBoundingClientRect().top-want;
      if(Math.abs(d)>1) window.scrollTo(0, Math.max(0, window.scrollY+d));
    };
    put();
    requestAnimationFrame(put);
    addEventListener('load', function(){ requestAnimationFrame(function(){ put();
      try{ if('scrollRestoration' in history) history.scrollRestoration='auto'; }catch(e){} }); });
  })();

  /* ── the format row navigates between the three products ── */
  [].forEach.call(document.querySelectorAll('#c9fmt .c9-f'),function(b){
    var key=b.getAttribute('data-f');
    var f=FMT[key]||{};
    var isCur=(key===CUR);
    b.classList.toggle('on',isCur);
    b.setAttribute('aria-selected',isCur?'true':'false');
    if(isCur) return;
    if(f.url){
      b.addEventListener('click',function(){ fmtRemember(); window.location=f.url; });
    }else{
      /* not sold here yet — say so instead of offering a dead tab */
      b.classList.add('c9-unavail');
      b.addEventListener('click',function(){
        var wrap=$('c9sizes'); if(!wrap) return;
        wrap.innerHTML='<p class="c9-note" style="grid-column:1/-1;margin:0">'+
          (key==='drops'
            ? 'Drops aren’t stocked in the UK yet — the 15:1 liquid extract is '+
              'available from <a href="'+EU_DROPS+'" rel="noopener">Solve Labs EU</a>.'
            : 'That format isn’t available yet.')+'</p>';
      });
    }
  });

  /* ── gallery ── */
  /* ── gallery lightbox: every frame opens full size; ‹ › / swipe / Esc; click the
     image to toggle 1:1 and pan. Built once, from JS, so every PDP template gets it. */
  var GLB=null, LBS={shots:[],alts:[],i:0};
  /* INSTANT GALLERY (17 Oct 2026: "the gallery is super slow… when I click the arrow it has to change straight away", on every
     product). Each arrow press fetched the next picture only then, at the full 1,400 px file (0.5-0.7 s on a fast line), and the old
     picture stayed on screen meanwhile, so the arrows felt dead. Now: the viewer asks for the size it draws (CDN &width), the
     neighbours are fetched ahead, every shot is fetched in the background once the viewer opens or the gallery is touched, and a
     press that beats the download shows the thumbnail already in the browser, sharpened the moment the big one lands. */
  var WARM={};
  function warm(u,low){ if(!u) return null; var im=WARM[u]; if(im) return im;
    im=new Image(); im.decoding='async'; if(low) try{ im.fetchPriority='low'; }catch(e){}
    im.onload=function(){ im._ok=1; }; im.src=u; WARM[u]=im; return im; }
  function lbW(){ var w=Math.min(window.innerWidth*0.96,1120)*Math.min(window.devicePixelRatio||1,2); return w>1250?0:(w>950?1200:900); }
  function lbSrc(src){ var w=lbW(); return w?SolveSized(src,w):src; }
  function warmAll(shots,from){ var n=shots.length; if(!n) return; from=from||0;
    for(var k=0;k<n;k++){ warm(lbSrc(shots[(from+k)%n]),k>2); } }
  function glb(){
    if(GLB) return GLB;
    var el=document.createElement('div'); el.className='glb'; el.id='glb'; el.setAttribute('role','dialog'); el.setAttribute('aria-modal','true'); el.setAttribute('aria-label','Product image');
    el.innerHTML='<div class="glb-scrim"></div>'+
      '<button type="button" class="glb-x" aria-label="Close">&times;</button>'+
      '<button type="button" class="glb-p" aria-label="Previous image">&#8249;</button>'+
      '<button type="button" class="glb-n" aria-label="Next image">&#8250;</button>'+
      '<figure class="glb-fig"><img id="glbImg" alt="" decoding="async"><figcaption><span class="glb-c mono"></span><span class="glb-cap"></span></figcaption></figure>';
    document.body.appendChild(el);
    /* A FILM IN THE GALLERY (7 Oct 2026, asked for on the Lion’s Mane page).
       The gallery data may carry "films": {"<part of a picture's file name>": "<mp4 address>"}. That picture is the film's tile
       (a still with a play button drawn on it), so the strip, the phone carousel and the plate need no change: wherever the tile
       is opened, the viewer plays the film in its place, and stops it when you move on or close. */
    function filmFor(src){ var F=IMG.films||{}; for(var k in F){ if(src&&String(src).indexOf(k)>-1) return F[k]; } return null; }
    function show(i){
      var n=LBS.shots.length; if(!n) return; LBS.i=(i+n)%n;
      var img=el.querySelector('#glbImg'), vid=el.querySelector('#glbVid'), mp4=filmFor(LBS.shots[LBS.i]);
      if(vid){ try{ vid.pause(); }catch(e){} }
      if(mp4){
        if(!vid){ vid=document.createElement('video'); vid.id='glbVid'; vid.controls=true; vid.setAttribute('playsinline',''); vid.preload='metadata'; img.parentNode.insertBefore(vid,img); }
        if(vid.getAttribute('src')!==mp4) vid.setAttribute('src',mp4);
        vid.setAttribute('aria-label',LBS.alts[LBS.i]||''); vid.style.display=''; img.style.display='none';
        var pr=vid.play(); if(pr&&pr.catch) pr.catch(function(){});
      } else { if(vid) vid.style.display='none'; img.style.display=''; }
      if(!mp4){
        var src=LBS.shots[LBS.i], big=lbSrc(src), want=LBS.i, bw=warm(big);
        img.style.width=''; img.style.opacity='';
        if(bw._ok) img.src=big;
        else {
          /* not here yet: the thumbnail the strip already loaded, drawn at the final size, then the sharp one */
          var sm=[SolveSized(src,900),SolveSized(src,700),SolveSized(src,600),SolveSized(src,360)].filter(function(u){ return WARM[u]&&WARM[u]._ok; })[0];
          if(sm){ var t=WARM[sm], ar=t.naturalWidth/(t.naturalHeight||1);
            img.style.width=Math.round(Math.min(window.innerWidth*(window.innerWidth<=720?.96:.94),1120,(window.innerHeight-150)*ar))+'px'; img.src=sm; }
          else { img.src=big; img.style.opacity='.35'; }      /* nothing in hand yet: the press still shows at once */
          bw.addEventListener('load',function(){ if(LBS.i===want&&!el.classList.contains('z')){ img.src=big; img.style.width=''; img.style.opacity=''; } });
        }
        var nn=LBS.shots.length; warm(lbSrc(LBS.shots[(LBS.i+1)%nn])); warm(lbSrc(LBS.shots[(LBS.i-1+nn)%nn]));
      }
      img.alt=LBS.alts[LBS.i]||'';
      el.querySelector('.glb-c').textContent=(LBS.i+1)+' / '+n;
      el.querySelector('.glb-cap').textContent=LBS.alts[LBS.i]||'';
      el.classList.remove('z');
      el.querySelector('.glb-p').style.display=el.querySelector('.glb-n').style.display=(n>1?'':'none');
    }
    function close(){ var v=el.querySelector('#glbVid'); if(v){ try{ v.pause(); }catch(e){} } el.classList.remove('on','z'); document.body.style.overflow=''; if(el._last&&el._last.focus){ try{ el._last.focus(); }catch(e){} } el._last=null; }
    el.querySelector('.glb-scrim').addEventListener('click',close);
    el.querySelector('.glb-x').addEventListener('click',close);
    el.querySelector('.glb-p').addEventListener('click',function(){ show(LBS.i-1); });
    el.querySelector('.glb-n').addEventListener('click',function(){ show(LBS.i+1); });
    el.querySelector('#glbImg').addEventListener('click',function(e){
      var fig=el.querySelector('.glb-fig'), was=el.classList.contains('z');
      el.classList.toggle('z');
      if(!was){ var full=LBS.shots[LBS.i]; if(full&&e.target.getAttribute('src')!==full){ e.target.style.width=''; e.target.src=full; } }
      if(!was){ /* zoom around the point clicked */
        var r=e.target.getBoundingClientRect(), fx=(e.clientX-r.left)/r.width, fy=(e.clientY-r.top)/r.height;
        requestAnimationFrame(function(){ fig.scrollLeft=fx*fig.scrollWidth-fig.clientWidth/2; fig.scrollTop=fy*fig.scrollHeight-fig.clientHeight/2; });
      }
    });
    document.addEventListener('keydown',function(e){
      if(!el.classList.contains('on')) return;
      if(e.key==='Escape') close(); else if(e.key==='ArrowLeft') show(LBS.i-1); else if(e.key==='ArrowRight') show(LBS.i+1);
    });
    var tx=null;
    el.addEventListener('touchstart',function(e){ tx=e.touches[0].clientX; },{passive:true});
    el.addEventListener('touchend',function(e){
      if(tx==null||el.classList.contains('z')) return; var dx=e.changedTouches[0].clientX-tx; tx=null;
      if(Math.abs(dx)>40) show(LBS.i+(dx<0?1:-1));
    },{passive:true});
    el._show=show; GLB=el; return el;
  }
  function openLB(shots, alts, i){
    var el=glb(); LBS.shots=shots.slice(); LBS.alts=(alts||[]).slice();
    el._last=document.activeElement; el._show(i||0); el.classList.add('on'); document.body.style.overflow='hidden';
    warmAll(LBS.shots,i||0);
    var x=el.querySelector('.glb-x'); if(x) x.focus();
  }
  (function(){ var h=$('g53'); if(!h) return; h.style.cursor='zoom-in';
    h.addEventListener('click',function(){
      var g=galNow(), shots=g.shots||[], i=shots.indexOf(h.getAttribute('src'));
      if(state.bundle&&BND&&BND.shot&&!setGal()){ openLB([BND.shot],[BND.n||''],0); return; }
      openLB(shots, g.alts, i<0?0:i);
    }); })();

  function gallery(){
    var g=galNow(), strip=$('t53');
    var shots=g.shots||[];
    if($('g53')&&shots[0]) $('g53').src=shots[0];
    if($('g57cap')&&g.cap) $('g57cap').textContent=g.cap;
    /* ON A PHONE THE PLATE IS A CAROUSEL (7 Oct 2026: "gallery doesn't work properly when you click, also you can't easily slide
       the gallery"). It was one fixed picture: it could not be dragged, and a tap on a thumbnail changed it AND threw the
       full-screen viewer over the page. Now every shot is a slide in a scroll-snap track laid over the plate: drag it, the
       counter and the thumbnails follow; a thumbnail scrolls the track; a tap on the picture opens the viewer at that shot.
       #g53 stays underneath (the bundle picture and the viewer still read it) and is kept on the current shot. */
    var plate=$('g53')&&$('g53').parentElement, phone=window.matchMedia&&window.matchMedia('(max-width:1080px)').matches;
    if(plate){
      [].forEach.call(plate.querySelectorAll('.p53-track,.p53-count'),function(n){n.parentNode.removeChild(n);});
      plate._go=null;
      plate.classList.remove('p53-plate--in');
      if(phone&&shots.length>1){
        var tr=document.createElement('div'); tr.className='p53-track'; tr.setAttribute('aria-label','Product pictures');
        tr.innerHTML=shots.map(function(src,i){
          return '<img '+(i>1?'loading="lazy" ':(i?'':'fetchpriority="high" '))+'decoding="async" draggable="false" src="'+SolveSized(src,900)+'" srcset="'+SolveSized(src,600)+' 600w, '+SolveSized(src,900)+' 900w, '+src+' 1400w" sizes="66vw" alt="'+((g.alts&&g.alts[i])||document.title).replace(/"/g,'&quot;')+'">';
        }).join('');
        var ct=document.createElement('span'); ct.className='p53-count'; ct.textContent='1 / '+shots.length;
        plate.appendChild(tr); plate.appendChild(ct);
        var at=0, raf=0;
        var mark=function(){
          raf=0; var w=tr.clientWidth||1, i=Math.max(0,Math.min(shots.length-1,Math.round(tr.scrollLeft/w)));
          if(i===at) return; at=i; ct.textContent=(i+1)+' / '+shots.length;
          plate.classList.toggle('p53-plate--in',i>0);   /* the format chip belongs to the pack shot: on every other picture it sat on the tile's own small print (7 Oct 2026, his phone screenshot of the film tile) */
          if($('g53')) $('g53').src=shots[i];
          if(strip){ var figs=strip.querySelectorAll('figure');
            [].forEach.call(figs,function(x,k){x.classList.toggle('on',k===i);});
            if(figs[i]) strip.scrollTo({left:Math.max(0,figs[i].offsetLeft-strip.offsetLeft-12),behavior:'smooth'}); }
        };
        /* the slides the carousel has loaded are the viewer's pictures too (same 900 px address on most phones) */
        [].forEach.call(tr.querySelectorAll('img'),function(im,i){
          var note=function(){ var k=SolveSized(shots[i],/[?&]width=600\b/.test(im.currentSrc||im.src)?600:(/[?&]width=900\b/.test(im.currentSrc||im.src)?900:1400));
            if(k.indexOf('width=1400')>-1) k=shots[i]; if(!WARM[k]) WARM[k]=im; if(WARM[k]===im) im._ok=1; };
          if(im.complete&&im.naturalWidth) note(); else im.addEventListener('load',note);
        });
        var eager=function(){ [].forEach.call(tr.querySelectorAll('img[loading="lazy"]'),function(im){ im.loading='eager'; }); };
        tr.addEventListener('touchstart',eager,{passive:true,once:true});
        tr.addEventListener('scroll',function(){ eager(); if(!raf) raf=requestAnimationFrame(mark); },{passive:true});
        tr.addEventListener('click',function(){ openLB(shots,g.alts,at); });
        plate._go=function(i){ tr.scrollTo({left:i*tr.clientWidth,behavior:'smooth'}); };
      }
    }
    if(!strip) return;
    strip.innerHTML=shots.map(function(src,i){
      var alt=(g.alts&&g.alts[i])||document.title;
      return '<figure'+(i===0?' class="on"':'')+'><img loading="lazy" decoding="async" src="'+SolveSized(src,700)+'" srcset="'+SolveSized(src,360)+' 360w, '+SolveSized(src,700)+' 700w" sizes="(max-width:1080px) 30vw, 340px" alt="'+alt+'"></figure>';
    }).join('');
    [].forEach.call(strip.querySelectorAll('img'),function(im,i){
      var note=function(){ var k=SolveSized(shots[i],/[?&]width=360\b/.test(im.currentSrc||im.src)?360:700); if(!WARM[k]) WARM[k]=im; if(WARM[k]===im) im._ok=1; };
      if(im.complete&&im.naturalWidth) note(); else im.addEventListener('load',note);
    });
    var touched=false, primeLB=function(){ if(touched) return; touched=true; warmAll(shots,0); };
    /* on a desktop, the viewer's pictures are fetched quietly once the page has loaded (low priority, never on Save-Data) */
    if(!phone&&!(navigator.connection&&navigator.connection.saveData)){
      var later=function(){ setTimeout(function(){ (window.requestIdleCallback||setTimeout)(primeLB); },1500); };
      if(document.readyState==='complete') later(); else window.addEventListener('load',later,{once:true});
    }
    [strip,plate].forEach(function(n){ if(n){ n.addEventListener('pointerenter',primeLB,{passive:true}); n.addEventListener('touchstart',primeLB,{passive:true}); } });
    /* the .rxf fold swaps the large picture from a thumbnail: fetch the full file on hover, before the click */
    if(strip.closest('.rxf')) [].forEach.call(strip.querySelectorAll('figure'),function(fig,i){ fig.addEventListener('pointerenter',function(){ warm(shots[i]); },{passive:true}); });
    [].forEach.call(strip.querySelectorAll('figure'),function(fig,i){
      fig.addEventListener('click',function(){
        if(state.bundle&&!setGal()){
          state.bundle=false; state.heroWas=null;
          [].forEach.call(document.querySelectorAll('#c9sizes .c9-s'),function(b){
            b.classList.toggle('on', !b.getAttribute('data-bundle') &&
              Number(b.getAttribute('data-v'))===state.k); });
          render();
        }
        if($('g53')) $('g53').src=shots[i];
        [].forEach.call(strip.querySelectorAll('figure'),function(x){x.classList.remove('on')});
        if($('g53')&&$('g53').parentElement) $('g53').parentElement.classList.toggle('p53-plate--in',i>0);
        fig.classList.add('on');
        /* on a phone a thumbnail moves the carousel; the viewer opens from the picture itself */
        var pl=$('g53')&&$('g53').parentElement; if(pl&&pl._go){ pl._go(i); return; }
        /* .rxf = the thumbnail-strip fold (Brain Tech): a thumb only swaps the hero,
           and the hero opens the viewer. Everywhere else the cards open it directly. */
        if(!strip.closest('.rxf')) openLB(shots, g.alts, i);
      });
    });
  }

  /* ── supply tiles = this product's own variants ── */
/* ══ FOLD FIX (fix_fold.py) ══ */
  /* A supply tile used to show the variant name and nothing else — the customer
     picked a size blind. The stylesheet already carried .tot / .rate / .badge;
     only the markup was missing. Savings are measured against the WORST per-day
     rate in the ladder, so a linear ladder honestly shows no badge at all. */
  function paintTiles(){
    var wrap=$('c9sizes'); if(!wrap) return;
    var g=IMG[CUR]||IMG.caps||{};
    var im=g.tile||(g.shots&&g.shots[0])||'';
    var supply=DATA.supply||{}, noun=DATA.unit||'day';
    if(TIERS.length<2 && !(TIERS[0]||{}).variant){ wrap.innerHTML=''; return; }
    /* One row. TIERS is already sorted with any bundle or plan last, so a plan
       is simply the fourth tile rather than a second grid. */
    /* 🛑 NEVER MORE THAN FOUR TILES IN THIS ROW.
       The row used to be everything TIERS held plus the bundle tile, and an
       earlier fix widened the grid to fit whatever that came to — which is how
       the protein ended up showing five: four flavours and The Engine Room.

       Two rules, in this order, because they can conflict:
       1. A purchasable variant is NEVER hidden. Overflow moves to the plans row
          below, it does not disappear.
       2. The bundle tile is a cross-sell and yields first — it already has its
          own section further down the page, so dropping it costs nothing.

       Plan- and bundle-NAMED variants ("Athlete Plan", "Immune Bundle") come
       out of the supply ladder too: mixing "9 Months" and "Skin Bundle" in one
       row asks the customer to compare a duration against a product. */
    var MAX_TILES=4;
    var sizes=TIERS.filter(function(z){ return !isBundle(z); });
    var sets =TIERS.filter(isBundle);
    if(sizes.length>MAX_TILES){
      sets=sizes.slice(MAX_TILES).concat(sets);
      sizes=sizes.slice(0,MAX_TILES);
    }
    var rates=sizes.filter(function(z){ return !isBundle(z); })
                   .map(function(z){ var d=supply[z.title]; return d? z.one/d : null; })
                   .filter(function(r){ return r!=null; });
    var worst=rates.length? Math.max.apply(null,rates) : 0;
    var best =rates.length? Math.min.apply(null,rates) : 0;
    /* A linear ladder prints the same rate on every tile — three identical lines
       that say nothing and make the row bulky. */
    var showRate=(worst && best && (1-best/worst) >= 0.02);
    function bundleTile(){
      if(!BND) return '';
      /* 🛑 The REAL product photographs, all three of them, composited live —
         not a generated pack shot and not a baked-out PNG.

         Higgsfield was asked for this tile with the three real photos attached
         as references. It returned a beautiful studio group and REDREW every
         label: the coffee became "ENERGIZE" carrying chaga and cordyceps (the
         real one is Lion's Mane and rhodiola), the greens claimed 38
         ingredients against a real 26, and it baked HEALTH CLAIMS into the
         artwork — IMMUNE SUPPORT, DIGESTIVE SUPPORT, BONE HEALTH, DETOXIFY.
         On a UK storefront that is a Reg 1924/2006 problem, and it is worse
         than a claim in a bundle NAME because it reads as a real label.
         Packaging is a legal document; a generative model cannot be trusted
         with it.

         Compositing live also beats baking 27 PNGs (one per unique set, per
         format): nothing to push, and the tile follows the product photography
         whenever it changes. */
      /* whole tile or nothing — one lifestyle-only product frames all three, so
         a tile never mixes floating products with framed ones */
      var framed=BND.items.some(function(x){ return LIFESTYLE_ONLY.indexOf(x.h)>-1; });
      /* a real group shot of this exact set, if one has been taken — one
         photograph of the three products together always beats three thumbnails */
      var inner = BND.shot
        ? '<span class="c9-bn-im shot"><img src="'+BND.shot+'" alt="" loading="lazy" decoding="async"></span>'
        : '<span class="c9-bn-im'+(framed?' framed':'')+'">'+ BND.items.map(function(x){
            return x.img? '<i><img src="'+x.img+'" alt="" loading="lazy" decoding="async"></i>':''; }).join('') +'</span>';
      return '<button type="button" class="c9-s c9-bn'+(state.bundle?' on':'')+'" data-bundle="1">'+
        '<span class="badge">Save '+BND.pct+'%</span>'+ inner +
        '<span class="nm">'+BND.n+'</span></button>';
    }
    function tile(z){
      var on=(!state.bundle && z.variant===state.k)?' on':'';
      if(z.available===false) on+=' c9-out';
      var d=supply[z.title]||0, r=d? z.one/d : 0;
      var save=(worst&&r&&r<worst)? Math.round((1-r/worst)*100) : 0;
      /* 🛑 `c9-out` was added to the class list and then styled nowhere, so a
         sold-out tier read as an ordinary choice and only revealed itself once
         the customer had spent a click and found a dead Add button. Say it on
         the tile, in the slot the save badge would have used. */
      var out=(z.available===false);
      return '<button type="button" class="c9-s'+on+'" data-v="'+z.variant+'">'+
        (out ? '<span class="flag">Sold out</span>'
             : (save>=5? '<span class="badge">Save '+save+'%</span>' : ''))+
        (im? '<img src="'+(packKey(z)? packSrc(packKey(z),true) : im)+'" alt="" decoding="async">' : '')+
        '<span class="nm">'+z.title+'</span></button>';
    }
    /* the bundle tile only takes a slot if one is genuinely free */
    var bt=(sizes.length<MAX_TILES)? bundleTile() : '';
    wrap.innerHTML=sizes.map(tile).join('') + bt;
    var cols=Math.min(wrap.children.length, MAX_TILES);
    if(cols>1) wrap.style.gridTemplateColumns='repeat('+cols+',minmax(0,1fr))';

    /* No template carries a plans row, so build one rather than drop the
       variants that were moved out of the ladder — they are buyable. */
    var pw=$('c9plans'), pl=$('c9plabel');
    if(!pw && sets.length && wrap.parentNode){
      pl=document.createElement('span');
      pl.className='mono r7-lbl c9-sl'; pl.id='c9plabel';
      pl.textContent='Plans and sets';
      pw=document.createElement('div');
      pw.className='c9-sizes c9-plans'; pw.id='c9plans';
      wrap.parentNode.insertBefore(pl, wrap.nextSibling);
      pl.parentNode.insertBefore(pw, pl.nextSibling);
    }
    if(pw && sets.length>1){
      pw.style.gridTemplateColumns='repeat('+Math.min(sets.length,MAX_TILES)+',minmax(0,1fr))';
    }
    if(pw){
      pw.innerHTML=sets.map(tile).join('');
      pw.hidden=!sets.length; if(pl) pl.hidden=!sets.length;
    }
    var all=[wrap].concat(pw?[pw]:[]);
    all.forEach(function(box){
      [].forEach.call(box.querySelectorAll('.c9-s'),function(b){
        b.addEventListener('click',function(){
          if(b.getAttribute('data-bundle')){
            state.bundle=true;
          } else {
            state.bundle=false;
            state.k=Number(b.getAttribute('data-v'));
          }
          all.forEach(function(x){ [].forEach.call(x.querySelectorAll('.c9-s'),
            function(y){ y.classList.remove('on'); }); });
          b.classList.add('on'); render();
        });
      });
    });
  }

  /* ── bundle mode ────────────────────────────────────────────────────────
     The set is a one-time purchase of three products, so the subscribe toggle
     is stood down rather than left promising a plan the basket cannot honour.
     The anchor takes whichever SIZE is selected upstairs, exactly as the set at
     the foot of the page does — the two must never quote different sizes. */
  /* Picking the set should SHOW the set — swap the gallery hero to the group
     shot, and put it back on the way out. Only where a shot exists; a bundle
     without one leaves the product's own photography alone. */
  function heroBundle(on){
    var hero=$('g53'); if(!hero || !BND || !BND.shot || setGal()) return;
    var cap=$('g57cap'), figs=document.querySelectorAll('.p53-thumbs figure');
    if(on){
      if(state.heroWas==null){
        state.heroWas = hero.getAttribute('src') || '';
        state.capWas  = cap ? cap.textContent : null;
        state.thumbWas = -1;
        [].forEach.call(figs,function(f,i){ if(f.classList.contains('on')) state.thumbWas=i; });
      }
      hero.src = BND.shot;
      /* 🛑 The hero plate is square and `object-fit:cover`, which crops a
         landscape group shot — the coffee lost its left edge and the greens its
         right. Fit the whole set instead, only while it is on screen. */
      if(hero.parentElement) hero.parentElement.classList.add('p53-plate--set');
      if(cap) cap.textContent = BND.n;
      [].forEach.call(figs,function(f){ f.classList.remove('on'); });
    } else if(state.heroWas!=null){
      hero.src = state.heroWas;
      if(hero.parentElement) hero.parentElement.classList.remove('p53-plate--set');
      if(cap && state.capWas!=null) cap.textContent = state.capWas;
      [].forEach.call(figs,function(f,i){ f.classList.toggle('on', i===state.thumbWas); });
      state.heroWas=null; state.capWas=null; state.thumbWas=null;
    }
  }

  function renderBundle(z){
    heroBundle(true);
    /* the anchor jar can be a sold-out tier — the tiles stay clickable so the
       swap can be offered — and a set that includes it cannot be bought */
    var ok = z.available!==false && !!z.variant;
    if($('qval')) $('qval').textContent=state.qty;
    var items=BND.items.map(function(x){
      return x.self ? {t:x.t, v:z.variant, price:(z.one||x.price), vt:z.title, self:true} : x; });
    var was=items.reduce(function(a,x){ return a+x.price; },0);
    var now=Math.round(was*(100-BND.pct)/100);
    if($('optSub')){ $('optSub').classList.remove('on'); $('optSub').style.display='none'; }
    if($('optOne')) $('optOne').classList.add('on');
    if($('onePr')) $('onePr').innerHTML=money(now);
    if($('subPr')) $('subPr').innerHTML=money(now);
    if($('vameta')) $('vameta').innerHTML=BND.min+' products \u00b7 '+money(was)+' \u2192 save '+BND.pct+'%';
    if($('vacta')) $('vacta').innerHTML=money(now*state.qty);
    var perks=document.querySelector('.va-perks'), onenote=$('vaonenote');
    if(perks) perks.style.display='none';
    if(onenote) onenote.style.display='';
    var stk=$('vastk');
    if(stk){ stk.innerHTML=stk.innerHTML.replace(/(<\/svg>)[\s\S]*$/, ok?'$1In stock':'$1Out of stock'); stk.className=ok?'':'oos'; }
    if($('c9note')) $('c9note').textContent='';
    var note=$('c9bnd');
    if(note){
      note.hidden=false;
      note.innerHTML='<b>'+BND.n+'</b> \u2014 '+BND.l+' '+
        items.map(function(x){ return x.self? '<em>'+x.t+'</em>' : x.t; }).join(' + ')+'. '+
        '<a href="#bundle">See the set</a>';
    }
    var add=$('add37');
    if(add){
      /* the stepper counts SETS: every line is multiplied, so the total on
         the button is the total that reaches the basket */
      add.dataset.items=JSON.stringify(items.map(function(x){
        return {id:x.v, quantity:state.qty}; }));
      add.dataset.discount=BND.code;
      add.disabled=!ok; add.classList.toggle('sold-out',!ok);
    }
  }

  function render(){
    var z=tier(); if(!z||!z.variant) return;
    var pk=state.bundle?'':packKey(z), gk=(state.bundle&&setGal())?'set':'n'+((pk&&pk.charAt(0)!=='~')?pk:1);
    if(gk!==state.galKey){      /* the set's seven pictures in, two packs or five in place of one, or the product's own back */
      var first=(state.galKey===undefined); state.galKey=gk; if(!first||gk!=='n1') gallery();
    }
    if(state.bundle && BND) return renderBundle(z);
    heroBundle(false);
    if($('c9bnd')) $('c9bnd').hidden=true;
    var one=z.one||0, sub=(z.sub!=null?z.sub:one), hasPlan=!!z.planId;
    /* the customer's chosen cadence wins over whichever plan the template
       happened to serialise first */
    var chosen=planFor(z);
    if(chosen){ sub=chosen.price; hasPlan=true; }
    if(!hasPlan && state.plan==='sub') state.plan='one';
    if($('optSub')){ $('optSub').disabled=!hasPlan; $('optSub').style.display=hasPlan?'':'none';
                     $('optSub').classList.toggle('on',state.plan==='sub'); }
    if($('optOne')) $('optOne').classList.toggle('on',state.plan==='one');
    if($('subPr')) $('subPr').innerHTML=money(sub);
    /* 🛑 "/mo" was hard-coded on every tier. A 100-day tier delivered quarterly
       would have said "/mo" and been wrong on the one number that matters. */
    var per=document.querySelector('#optSub .pr em');
    if(per) per.textContent = cadence(z);
    paintFreq(z);
    if($('subWas')) $('subWas').innerHTML=money(one);
    if($('onePr')) $('onePr').innerHTML=money(one);
    /* Seal gives 20%, Kaching gives 15% on the gummies — a static badge
       was wrong on whichever product it did not describe. */
    var svb=document.querySelector('#optSub .save');
    if(svb){ var pct=(one>0&&sub<one)? Math.round((one-sub)/one*100) : 0;
             svb.textContent='Save '+pct+'%'; svb.hidden=!pct; }

    var unit=(state.plan==='sub')?sub:one;
    var srv=(DATA.supply||{})[z.title]||0, noun=DATA.unit||'day';
    var meta=z.title;
    if($('vameta')) $('vameta').innerHTML = srv
      ? (meta+' · '+pserv(unit,srv)+' a '+noun) : meta;
    if($('vacta')) $('vacta').innerHTML=money(unit*state.qty);
    if($('qval')) $('qval').textContent=state.qty;
    /* "In stock" was static text, so a sold-out tier still claimed to be
       in stock until you pressed the disabled button. */
    var stk=$('vastk');
    if(stk){ var inv=z.available!==false;
             stk.innerHTML=stk.innerHTML.replace(/(<\/svg>)[\s\S]*$/, '$1'+(inv?'In stock':'Out of stock'));
             stk.className=inv?'':'oos'; }
    var c9n=$('c9note');
    if(c9n){
      if(z.available===false){
        var alt=nearestInStock(z);
        c9n.innerHTML = z.title+' is out of stock right now.'+
          (alt ? ' <button type="button" class="c9-swap" data-v="'+alt.variant+
                 '">Switch to '+alt.title+'</button>' : '');
      } else c9n.innerHTML='';
    }

    var perks=document.querySelector('.va-perks'), onenote=$('vaonenote');
    if(perks) perks.style.display=(state.plan==='sub')?'':'none';
    if(onenote) onenote.style.display=(state.plan==='sub')?'none':'';

    var add=$('add37');
    if(add){
      var item={id:z.variant,quantity:state.qty};
      if(state.plan==='sub'){
        var pl=planFor(z);
        if(pl) item.selling_plan=pl.id;
        else if(z.planId) item.selling_plan=z.planId;
      }
      add.dataset.items=JSON.stringify([item]);
      delete add.dataset.discount;
      var ok=z.available!==false && !!z.variant && one>0;
      add.disabled=!ok; add.classList.toggle('sold-out',!ok);
    }
  }

  ['optSub','optOne'].forEach(function(id){
    var b=$(id); if(!b) return;
    b.addEventListener('click',function(){
      if(id==='optSub'&&b.disabled) return;
      state.plan=(id==='optSub')?'sub':'one'; render();
    });
  });
  if($('qminus')) $('qminus').addEventListener('click',function(){ if(state.qty>1){state.qty--; render();} });
  if($('qplus'))  $('qplus').addEventListener('click',function(){ if(state.qty<9){state.qty++; render();} });
  var c9noteEl=$('c9note');
  if(c9noteEl) c9noteEl.addEventListener('click',function(e){
    var b=e.target.closest? e.target.closest('.c9-swap') : null; if(!b) return;
    state.bundle=false; state.k=Number(b.getAttribute('data-v'));
    paintTiles(); render();
  });
  gallery(); paintTiles(); render();
})();


(function(){
  var ul=document.getElementById('vainc'); if(!ul) return;
  var SETS={
    sub:['Free UK delivery over \u00a350','Pause, skip or cancel anytime',
         '20% off every order'],
    one:['Ships in 1\u20132 working days','No subscription, no commitment',
         '60-day money-back guarantee']
  };
  function paint(){
    var sub=document.querySelector('#optSub.on')!==null;
    ul.innerHTML=SETS[sub?'sub':'one'].map(function(t){return '<li>'+t+'</li>'}).join('');
  }
  ['optSub','optOne'].forEach(function(id){
    var b=document.getElementById(id);
    if(b) b.addEventListener('click',function(){ setTimeout(paint,0) });
  });
  paint();
})();


(function(){
  /* 6 Oct 2026: the UK estimate was today+1..2 days while the cheapest rate at checkout is "UK Standard: 3-5 Days"
     (and the shipping policy says 3-5 business days). A page may not promise faster than the checkout: it is 3..5 now. */
  /* 🛑 6 Oct 2026: the region is no longer a choice kept in localStorage. It is the country Shopify Markets is quoting
     (the sheet control prints it from Liquid and switches it through Shopify's localization form), and it drives two
     things here: the delivery estimate in the buy card and which row the shipping dialog highlights. */
  var R={uk:{s:'UK',lo:3,hi:5,row:0}, eu:{s:'Europe',lo:3,hi:5,row:1}, us:{s:'US',lo:5,hi:10,row:2}};
  var M=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var $=function(id){return document.getElementById(id)};
  var cc=(($('rgnFlag')&&$('rgnFlag').getAttribute('data-cc'))||(window.Shopify&&Shopify.country)||'GB').toUpperCase();
  var cur = cc==='GB' ? 'uk' : ((cc==='US'||cc==='CA') ? 'us' : 'eu');
  try{ localStorage.removeItem('solve.region'); }catch(e){}
  function flag(c){ try{ return String.fromCodePoint.apply(String,c.toUpperCase().split('').map(function(x){return 127397+x.charCodeAt(0);})); }catch(e){ return ''; } }

  function dates(lo,hi){
    var a=new Date(), b=new Date();
    a.setDate(a.getDate()+lo); b.setDate(b.getDate()+hi);
    return (a.getMonth()===b.getMonth())
      ? a.getDate()+'\u2013'+b.getDate()+' '+M[b.getMonth()]
      : a.getDate()+' '+M[a.getMonth()]+' \u2013 '+b.getDate()+' '+M[b.getMonth()];
  }
  function paint(){
    var r=R[cur];
    [].forEach.call(document.querySelectorAll('#rgnFlag[data-cc],#rgnList button[data-cc]'),function(el){
      var i=el.tagName==='I'?el:el.querySelector('i'); if(i) i.textContent=flag(el.getAttribute('data-cc')); });
    if($('delivRgn'))$('delivRgn').textContent=r.s;
    if($('deliv58')) $('deliv58').textContent=dates(r.lo,r.hi);
    var rows=document.querySelectorAll('.shp-tbl .r:not(.h)');
    [].forEach.call(rows,function(x,i){ x.classList.toggle('now', i===r.row); });
  }
  function close(){ var l=$('rgnList'); if(l){ l.hidden=true;
    $('rgnBtn').setAttribute('aria-expanded','false'); } }

  if($('rgnBtn')) $('rgnBtn').addEventListener('click',function(e){
    e.stopPropagation();
    var l=$('rgnList'); if(!l) return;        /* 7 Oct 2026: the pill opens snippets/locale-picker.liquid now */
    var open=l.hidden;
    l.hidden=!open; this.setAttribute('aria-expanded', open?'true':'false');
  });
  /* a choice in the list is a submit button of Shopify's localization form: let it through */
  document.addEventListener('click',function(e){ if(!e.target.closest('.rgn')) close(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
  paint();
})();


(function(){
  var m=document.getElementById('shp'); if(!m) return;
  var last=null;
  function open(){ last=document.activeElement; m.classList.add('on');
    m.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden';
    var x=m.querySelector('.shp-x'); if(x) x.focus(); }
  function close(){ m.classList.remove('on'); m.setAttribute('aria-hidden','true');
    document.body.style.overflow=''; if(last&&last.focus) last.focus(); }
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-shp]')){ e.preventDefault(); open(); return; }
    if(e.target.closest('[data-shpc]') && m.classList.contains('on')) close();
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape' && m.classList.contains('on')) close();
  });
})();


(function(){
  var b=document.getElementById('dropsBar'), x=document.getElementById('dropsX');
  if(!b||!x) return;
  /* The dismissal used to be written to localStorage, so one tap on the ×
     killed the bar permanently on that device - it never came back, on any
     page, ever. It is a promotional strip, not a consent notice: closing it
     should clear it out of the way for THIS view only. Nothing is persisted
     now, so a refresh brings it back.
     (This also self-heals anyone already carrying solve.drops=off: the key
     is no longer read, so the bar returns for them too.) */
  x.addEventListener('click',function(){ b.classList.add('off'); });
  try{ localStorage.removeItem('solve.drops'); }catch(e){}
})();


/* mega menu — the Huel shape. The rail no longer lists eight nouns of three
   different kinds (categories, then hours); it names the WAY you want to shop,
   and the panel answers with tiles. A tile whose set we can derive exactly
   opens the products inside the panel; a tile backed by a curated Shopify
   collection we cannot see from the client navigates to it.

   Tiles carry no counts on purpose. The store's collections and our tag-derived
   sets disagree on several numbers — best-sellers is 10 in Shopify and 11 by
   the menu flag, and the Lion's Mane collection holds 6 products of which only
   3 are Lion's Mane SKUs — and a count that contradicts the page it links to is
   worse than no count. Numbers appear only inside a drill, counted from the
   very list being shown. */
(function(){
  var D=window.MMDATA=(function(){try{return JSON.parse(document.getElementById('mm-catalogue').textContent)}catch(e){return []}})();
  var tilesEl=document.getElementById('mmTiles');
  if(!tilesEl) return;
  var drillEl=document.getElementById('mmDrill'),
      grid=document.getElementById('mmGrid'),
      fmtsEl=document.getElementById('mmFmts'),
      backT=document.getElementById('mmBackT'),
      allL=document.getElementById('mmAll'),
      moreL=document.getElementById('mmMore'),
      modes=[].slice.call(document.querySelectorAll('.mm-m'));

  var FMT={caps:'Capsules',powder:'Powder',drops:'Drops'};
  var ORDER=['caps','powder','drops'];
  var CAP=4;

  function cat(c){ return function(x){ return x[9]===c; }; }
  function fmt(){ var a=[].slice.call(arguments);
    return function(x){ return a.indexOf(x[2])>-1; }; }
  function goal(g){ return function(x){ return (x[8]||[]).indexOf(g)>-1; }; }
  /* membership in a real Shopify collection, emitted live at index 11.
     This is what lets the species and goal tiles open their products in the
     panel instead of navigating away: we can finally enumerate exactly what
     the collection page would show, so the list and its count agree with it. */
  function col(h){ return function(x){ return (x[11]||[]).indexOf(h)>-1; }; }
  function best(x){ return x[7]===1; }

  /* drill:1 means the set is ours to compute and the panel shows it in place.
     Without it the tile is a link — the honest behaviour when the collection
     behind it is curated in Shopify and we cannot enumerate it from here. */
  var TILES={
    collection:[
      /* was the hand-kept mm_best flag (11) against a Shopify collection of 10
         that disagreed on 6 of them. Reads the collection now — but carries NO
         count, because best-sellers is the one collection holding products the
         menu catalogue does not: a starter pack, a premium extract, and what
         looks like a duplicate of Mushroom Cacao. We can show 7 of its 10, so
         printing a number here would contradict the page it opens. */
      {t:'Best sellers',   s:'Our most popular',    u:'/collections/best-sellers',        f:col('best-sellers'),     drill:1, count:false},
      {t:'Mushrooms',      s:'Seven species, pure or blended',u:'/collections/mushrooms',          f:cat('mushrooms'),        drill:1, fmts:1},
      {t:'Gummies',        s:'Focus, calm, and one for kids',u:'/collections/mushroom-gummies-1',  f:cat('gummies'),          drill:1},
      {t:'Coffee & drinks',s:'Ground, matcha, cacao, yerba', u:'/collections/mushroom-elixirs',    f:fmt('coffee','elixir'),  drill:1},
      {t:'Wellness',       s:'The daily, non-mushroom shelf',u:'/collections/wellness',            f:cat('wellness'),         drill:1},
      {t:'Performance',    s:'Protein, creatine, electrolytes',u:'/collections/athletic-performance',f:cat('performance'),    drill:1}
    ],
    mushroom:[
      {t:'Lion’s Mane',     s:'Focus, without caffeine',       u:'/collections/lions-mane',       f:col('lions-mane'),       drill:1},
      {t:'Reishi',          s:'The end of the day',            u:'/collections/reishi',           f:col('reishi'),           drill:1},
      {t:'Chaga',           s:'Wild birch, not a soft cap',    u:'/collections/chaga',            f:col('chaga'),            drill:1},
      {t:'Cordyceps',       s:'Before the effort, not after',  u:'/collections/cordyceps',        f:col('cordyceps'),        drill:1},
      {t:'Mushroom Complex',s:'All four, in one',              u:'/collections/mushroom-complex', f:col('mushroom-complex'), drill:1},
      {t:'Tremella',        s:'What the cosmetics trade buys', u:'/collections/tremella',         f:col('tremella'),         drill:1},
      {t:'Maitake',         s:'Hen of the woods, concentrated',u:'/collections/maitake',          f:col('maitake'),          drill:1},
      {t:'Wood Ear',        s:'Near-tasteless, goes anywhere', u:'/collections/wood-ear',         f:col('wood-ear'),         drill:1}
    ],
    format:[
      {t:'Capsules',       s:'Measured, and no taste',       u:'/collections/capsules', f:fmt('caps'),   drill:1},
      {t:'Powders',        s:'Into coffee, or a smoothie',   u:'/collections/powders',  f:fmt('powder'), drill:1},
      {t:'Liquid drops',   s:'Under the tongue, ten seconds',u:'/collections/drops',    f:fmt('drops'),  drill:1},
      {t:'Gummies',        s:'Chewed, and actually pleasant',u:'/collections/mushroom-gummies-1', f:fmt('gummies'), drill:1},
      {t:'Coffee & drinks',s:'Ground, matcha, cacao, yerba', u:'/collections/mushroom-elixirs',   f:fmt('coffee','elixir'), drill:1}
    ],
    /* these are the store's own curated collections, which is why they are keyed
       on membership and not on our goal tags — the tags are a different, looser
       idea of the same word (Focus holds 7 products; the brain tag holds 10) */
    goal:[
      {t:'Focus',           s:'Hold a thought for an hour',     u:'/collections/focus',  f:col('focus'),  drill:1},
      {t:'Energy',          s:'Without the three o’clock drop', u:'/collections/energy', f:col('energy'), drill:1},
      {t:'Calm & sleep',    s:'Down, and not knocked out',      u:'/collections/sleep',  f:col('sleep'),  drill:1},
      {t:'Stress',          s:'For the weeks that ask a lot',   u:'/collections/stress', f:col('stress'), drill:1},
      {t:'Daily essentials',s:'The shelf you refill',           u:'/collections/daily',  f:col('daily'),  drill:1}
    ],
    day:[
      {t:'Morning',  s:'Start the day focused',   u:'/collections/morning',  f:function(x){return x[10]==='morning';},  drill:1},
      {t:'Afternoon',s:'The hour it usually goes',   u:'/collections/afternoon',f:function(x){return x[10]==='afternoon';},drill:1},
      {t:'Evening',  s:'Down, at the end of it',     u:'/collections/evening',  f:function(x){return x[10]==='evening';},  drill:1}
    ]
  };

  /* 6 Oct 2026 — ONE TAXONOMY. The shelves, the goals and the moments are written once, in snippets/shop-taxonomy.liquid, and
     arrive here as JSON. They replace the three hand-kept lists above, so this menu, the phone menu, the footer and every
     collection page show the same names in the same order, and each tile counts the collection it opens (membership, index 11)
     and not a second classification kept in the catalogue. Without the JSON the lists above still stand. */
  (function(){
    var TX; try{ TX=JSON.parse(document.getElementById('shop-taxonomy').textContent); }catch(e){ return; }
    function mk(o){ return {t:o.t, s:o.s, u:o.u, f:col(o.h), drill:1, count:o.h!=='best-sellers', fmts:o.h==='mushrooms'?1:0}; }
    if(TX.shelves&&TX.shelves.length) TILES.collection=TX.shelves.map(mk);
    if(TX.goals&&TX.goals.length)     TILES.goal=TX.goals.map(mk);
    if(TX.moments&&TX.moments.length) TILES.day=TX.moments.map(mk);
  })();

  var COLS={collection:3,mushroom:4,format:3,goal:3,day:3,choose:2};
  var ARROW='<svg viewBox="0 0 24 24"><path d="M5 12h13M12 5l7 7-7 7"/></svg>';

  /* up to three jars, bestsellers first so the cluster leads with the product
     someone is most likely to recognise */
  function art(f){
    if(!D.length||!f) return '';
    var set=D.filter(f).filter(function(x){return !!x[6];});
    set=set.filter(best).concat(set.filter(function(x){return !best(x);}));
    return set.slice(0,3).map(function(x){
      return '<img loading="lazy" decoding="async" src="'+x[6]+'" alt="">';
    }).join('');
  }

  /* A category is now a row in a filter list, not a poster. Its one thumbnail
     is there so the list is scannable by sight; the products get the pictures.
     The row still links to the collection for anyone who wants the full page. */
  function tileHTML(d,m,i){
    var thumb=(function(){
      if(!D.length||!d.f) return '';
      var set=D.filter(d.f).filter(function(x){return !!x[6];});
      set=set.filter(best).concat(set.filter(function(x){return !best(x);}));
      return set.length ? '<img loading="lazy" decoding="async" src="'+set[0][6]+'" alt="">' : '';
    })();
    var preview=d.drill && D.filter(d.f).length;
    return (preview ? '<button type="button" class="mm-tile" aria-pressed="false" aria-controls="mmDrill" data-d="'+m+':'+i+'">' : '<a class="mm-tile" href="'+d.u+'">')+
      '<span class="im">'+thumb+'</span>'+
      '<span class="tl"><b>'+d.t+'</b><span>'+d.s+'</span></span>'+
      '<span class="ar" aria-hidden="true">'+ARROW+'</span>'+(preview?'</button>':'</a>');
  }

  /* the second card was hard-coded to href="#audit" with the data-audit hook,
     which only works on a page that actually contains the #audit modal. On the
     homepage — and on any page without it — that was a dead click, so the card
     falls back to a real destination when the modal is not present. */
  function chooseHTML(){
    var hasAudit=!!document.getElementById('audit');
    var second = hasAudit
      ? '<a class="mm-tile mm-tile-x" href="#audit" data-audit>'+
        '<span class="tl"><b>The category audit</b><span>273 products on the shelf. '+
        'One of them publishes a DNA report. Here is how we checked.</span></span>'+
        '<span class="ar">'+ARROW+'</span></a>'
      : '<a class="mm-tile mm-tile-x" href="/blogs/guides">'+
        '<span class="tl"><b>Read the guides</b><span>What to take, when to take it, '+
        'and how much — written for people who have not done this before.</span></span>'+
        '<span class="ar">'+ARROW+'</span></a>';
    return '<a class="mm-tile mm-tile-x" href="/pages/quiz">'+
      '<span class="tl"><b>Solve your day</b><span>Eight questions, then a morning, '+
      'an afternoon and an evening built round what you actually do.</span></span>'+
      '<span class="ar">'+ARROW+'</span></a>'+second;
  }

  var mode='collection';
  function renderTiles(){
    tilesEl.setAttribute('data-c',COLS[mode]||3);
    tilesEl.innerHTML = mode==='choose' ? chooseHTML()
      : (TILES[mode]||[]).map(function(d,i){return tileHTML(d,mode,i);}).join('');
    cur=null;
    if(mode==='choose'){ closeDrill(); return; }
    var first=tileDef(tilesEl.querySelector('.mm-tile[data-d]'));
    if(first) openDrill(first); else closeDrill();
  }

  /* ── the drill: the products, inside the panel ─────────────────────────── */
  var cur=null, sub='';
  function renderDrill(){
    if(!cur) return;
    var list=D.filter(cur.f);
    var subs = cur.fmts ? ORDER.filter(function(k){
      return list.some(function(x){return x[2]===k;}); }) : [];
    var shown = sub ? list.filter(function(x){return x[2]===sub;}) : list;

    if(cur.fmts){
      var SP=['lions-mane','reishi','chaga','cordyceps','tremella','maitake',
              'auricularia','complex'];
      var rank=function(x){ for(var i=0;i<SP.length;i++){
        if((x[5]||'').indexOf(SP[i])>-1) return i; } return SP.length; };
      shown=shown.slice().sort(function(a,b){return rank(a)-rank(b);});
    }

    if(backT) backT.textContent=cur.t;
    allL.href=cur.u;
    allL.textContent = cur.count===false ? 'Shop best sellers →'
                                        : 'Shop all '+list.length+' →';

    if(subs.length){
      fmtsEl.hidden=false;
      fmtsEl.innerHTML=subs.map(function(k){
        return '<button class="mm-f'+(sub===k?' on':'')+'" data-s="'+k+'">'+FMT[k]+'</button>';
      }).concat(['<button class="mm-f'+(sub?'':' on')+'" data-s="">All '+list.length+'</button>']).join('');
    } else { fmtsEl.hidden=true; fmtsEl.innerHTML=''; }

    grid.innerHTML = shown.slice(0,CAP).map(function(x){
      var nm=x[0];
      if(cur.fmts && sub) nm=nm.replace(/^Pure\s+/,'').replace(/\s+(Capsules|Powder|Drops)$/i,'');
      return '<a class="mm-card" href="'+x[5]+'"><figure><img loading="lazy" decoding="async" src="'+
        x[6]+'" alt="'+x[0]+'"></figure><span class="tx"><b>'+nm+'</b></span>'+
        '<span class="p">'+(x[4]||'')+'</span></a>';
    }).join('');

    if(shown.length>CAP){ moreL.hidden=false; moreL.href=cur.u;
      moreL.textContent=cur.count===false ? allL.textContent : 'See all '+shown.length+' →'; }
    else { moreL.hidden=true; }
  }
  function openDrill(d){
    if(cur===d) return;
    cur=d; sub=d.fmts?'caps':'';
    drillEl.hidden=false; renderDrill();
    [].forEach.call(tilesEl.querySelectorAll('.mm-tile'),function(t){
      t.classList.toggle('on', t===d._el);
      if(t.tagName==='BUTTON')t.setAttribute('aria-pressed',String(t===d._el));
    });
  }
  function closeDrill(){ cur=null; drillEl.hidden=true; }

  /* the header controller closes the whole panel on any <a> click inside it,
     so a drilling tile has to stop the click before it reaches that listener */
  function tileDef(a){
    var k=a&&a.getAttribute('data-d'); if(!k) return null;
    var p=k.split(':'), d=(TILES[p[0]]||[])[+p[1]];
    if(!d || !D.filter(d.f).length) return null;
    d._el=a; return d;
  }
  tilesEl.addEventListener('click',function(e){
    var d=tileDef(e.target.closest('.mm-tile'));
    if(d){e.preventDefault();e.stopPropagation();openDrill(d);}
  });
  fmtsEl.addEventListener('click',function(e){
    var b=e.target.closest('.mm-f'); if(!b) return;
    e.stopPropagation();
    sub=b.getAttribute('data-s'); renderDrill();
    var selected=fmtsEl.querySelector('[data-s="'+sub+'"]');if(selected)selected.focus();
  });
  modes.forEach(function(b){
    function go(){ var k=b.getAttribute('data-m'); if(k===mode) return;
      mode=k; modes.forEach(function(o){o.classList.toggle('on',o===b);o.setAttribute('aria-pressed',String(o===b));});
      closeDrill(); renderTiles(); }
    b.addEventListener('click',function(e){e.stopPropagation();go();});
    b.setAttribute('aria-pressed',String(b.classList.contains('on')));
    b.setAttribute('aria-controls','mmTiles');
  });

  renderTiles();
})();


(function(){
  var el=document.getElementById('mmMobile'); if(!el||typeof MMDATA==='undefined') return;
  /* x[7] is the bestseller flag, x[9] the category. Filtering on the flag
     alone put Brain Tech, B-Complex, Shilajit, cacao, coffee and the focus
     gummies inside an accordion headed "Mushrooms". Desktop keeps
     Bestsellers and Mushrooms as two separate rail tabs; this strip lives
     under the Mushrooms heading, so it is the intersection of the two. */
  el.innerHTML=MMDATA.filter(function(x){return x[7]===1&&x[9]==='mushrooms';}).map(function(x){
    return '<a href="'+x[5]+'"><figure><img loading="lazy" decoding="async" src="'+x[6]+'" alt="'+x[0]+'"></figure>'+
           '<b>'+x[0]+'</b><span class="p">'+(x[4]?x[4]:x[1])+'</span></a>';
  }).join('');
})();


/* 58c13 · real Shopify add-to-cart + header cart wiring */
(function(){
  var T=window.SolveTheme||{}, addUrl=T.cartAddUrl||'/cart/add.js', cartUrl=T.cartUrl||'/cart';
  var cc=document.getElementById('cartCount');
  function add(btn){
    var raw=btn.dataset.items; if(!raw||btn.disabled) return;
    var items; try{ items=JSON.parse(raw); }catch(e){ return; }
    items=items.filter(function(i){return i.id});
    if(!items.length) return;
    var old=btn.innerHTML; btn.disabled=true;
    fetch(addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){ if(!r.ok) throw r; return r.json(); })
      .then(function(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); })
      .then(function(cart){ if(cc){cc.textContent=cart.item_count;cc.classList.toggle('has',cart.item_count>0);}
        btn.innerHTML='Added ✓';
        /* a bundle goes to the basket THROUGH the discount endpoint, so the
           saving the tile promised is the saving the basket shows */
        var code=btn.dataset.discount;
        var to = code ? ('/discount/'+code+'?redirect='+encodeURIComponent(cartUrl)) : cartUrl;
        /* a plain add opens the Smart Cart in place (6 Oct 2026); the button comes back so a second pack can be added */
        setTimeout(function(){ var S=window.SolveCart;
          if(S && S.ready()) S.go(to,cartUrl,function(){ btn.disabled=false; btn.innerHTML=old; }); else window.location=to; },400); })
      .catch(function(err){ btn.disabled=false; btn.innerHTML=old;
        /* Shopify answers 422 with a reason (sold out, plan not valid for this
           variant). Redirecting to a basket that does not contain the item
           hid every one of those; now the reason lands in the buy box. */
        var n=document.getElementById('c9note');
        var show=function(m){ m=m||'Could not add to basket. Please try again.'; if(n){ n.textContent=m; } else { alert(m); } };
        if(err && typeof err.json==='function') err.json().then(function(j){ show(j.description||j.message); }).catch(function(){ show(); });
        else show(); });
  }
  var a=document.getElementById('add37');
  if(a) a.addEventListener('click',function(e){ e.preventDefault(); add(a); });
  /* On chrome pages theme.js owns the icon and opens the drawer; binding a
     navigation here as well made the drawer flash open and then leave the
     page. Navigate only where there is no drawer to open (the bare PDPs). */
  var oc=document.getElementById('openCart');
  if(oc && !document.getElementById('drawer')) oc.addEventListener('click',function(e){ e.preventDefault();
    if(!(window.SolveCart && SolveCart.open())) window.location=cartUrl; });
})();


/* ── scroll-reveal safety net ──────────────────────────────────────────────
   Several modules (the category audit, the editorial strip, the cross-sell)
   start hidden and are revealed by an IntersectionObserver adding `.in`. If
   that observer never fires — a restored scroll position, a threshold that a
   tall module never satisfies, an engine quirk — the module renders blank.
   This re-checks on scroll and reveals anything that has reached the viewport,
   so a missed callback can never leave a section empty. */
(function(){
  var SEL='.auda, .people.reveal, .bstack.reveal, .reveal';
  function sweep(){
    var done=true;
    [].forEach.call(document.querySelectorAll(SEL),function(e){
      if(e.classList.contains('in')) return;
      var r=e.getBoundingClientRect();
      if(r.top < (window.innerHeight||0) && r.bottom > 0) e.classList.add('in');
      else done=false;
    });
    return done;
  }
  addEventListener('scroll',sweep,{passive:true});
  addEventListener('resize',sweep);
  addEventListener('load',function(){ sweep(); setTimeout(sweep,600); });
  sweep();
})();

/* ══ PDP BUNDLE (add_bundles.py) ══ */
/* The bundle at the foot of the page.

   Four things it has to get right:
     1. the total must be arithmetic on live variant prices, never a hard-coded
        number — the old cross-sell shipped "£62.74" baked into the markup;
     2. card one has to follow the buy box, or the set quotes a different size
        from the one the visitor picked upstairs;
     3. anything already in the basket must be unticked, or one click silently
        doubles it;
     4. below the minimum the copy must say so rather than promise a saving
        the discount will refuse to apply.
*/
(function(){
  var row=document.getElementById('bndRow'), cta=document.getElementById('bndCta');
  if(!row||!cta) return;
  var PCT=15/100, MIN=3, CODE='BUNDLE15';
  var wasEl=document.getElementById('bndWas'), nowEl=document.getElementById('bndNow'),
      saveEl=document.getElementById('bndSave'), nEl=document.getElementById('bndN'),
      noteEl=document.getElementById('bndNote'), anchor=row.querySelector('.bnd-card[data-anchor]');
  function money(n){ return (window.SolveMoney||function(v){return v.toFixed(2)})(n); }
  function cards(){ return [].slice.call(row.querySelectorAll('.bnd-card')); }
  function picked(){ return cards().filter(function(c){ var i=c.querySelector('input'); return i&&i.checked; }); }

  function sync(){
    var sel=picked(), was=0;
    sel.forEach(function(c){ was+=parseFloat(c.dataset.price)||0; });
    var on=sel.length>=MIN, now=on?was*(1-PCT):was;
    nEl.textContent = sel.length===1 ? '1 item' : sel.length+' items';
    wasEl.textContent = money(was); wasEl.hidden=!on;
    nowEl.textContent = sel.length ? money(now) : '';
    saveEl.textContent = 'Save '+money(was-now); saveEl.hidden=!on;
    var all=cards(), stocked=all.filter(function(c){ return c.classList.contains('bnd-have'); }).length;
    var allHave = all.length>0 && stocked===all.length && sel.length===0;
    cta.disabled = sel.length===0 && !allHave;
    cta.innerHTML = allHave ? 'View your basket'
                  : (sel.length===0 ? 'Choose at least one'
                  : (on ? 'Add the bundle &mdash; '+money(now)
                        : 'Add '+sel.length+' &mdash; '+money(now)));
    /* a page whose set is a SYSTEM names its own button (data-label, translated with the page). 🛑 The expression above is a
       patch target of tools/i18n/build.py: leave it character for character. */
    if(on && !allHave && sel.length && cta.getAttribute('data-label')) cta.innerHTML = cta.getAttribute('data-label')+' &mdash; '+money(now);
    noteEl.innerHTML = allHave
      ? 'Every item in this set is already in your basket.'
      : (on
        ? (15+'% comes off in the basket, as a one-time purchase. Untick anything you already have.')
        : ('Add '+(MIN-sel.length)+' more to take '+15+'% off the set.'));
  }
  row.addEventListener('change',function(e){ if(e.target.matches('input')) sync(); });

  /* card one mirrors the buy box: the engine rewrites #add37's data-items on
     every tier and plan change, so that attribute is the single source of truth
     for what the visitor has actually selected. */
  var add=document.getElementById('add37');
  var tiers=(function(){ try{
      return JSON.parse(document.getElementById('pdp-formats').textContent).tiers||[];
    }catch(e){ return []; } })();
  var inCart={};
  function syncAnchor(){
    if(!anchor||!add||!tiers.length) return;
    var id=null;
    try{ var it=JSON.parse(add.dataset.items||'[]'); if(it[0]) id=it[0].id; }catch(e){}
    if(!id) return;
    for(var i=0;i<tiers.length;i++){
      if(String(tiers[i].variant)!==String(id)) continue;
      anchor.dataset.variant=String(id);
      anchor.dataset.price=String(tiers[i].one/100);
      var pv=anchor.querySelector('.bnd-pv'), vt=anchor.querySelector('.bnd-vt');
      if(pv) pv.textContent=money(tiers[i].one/100);
      if(vt) vt.textContent=tiers[i].title;
      var inp=anchor.querySelector('input'), was=inp?inp.checked:true;
      mark(anchor);
      if(inp && !inCart[String(id)]) inp.checked=was;
      break;
    }
    sync();
  }
  if(add && 'MutationObserver' in window){
    new MutationObserver(syncAnchor).observe(add,{attributes:true,attributeFilter:['data-items']});
  }

  /* already in the basket -> untick, and say why */
  function mark(c){
    var k=c.querySelector('.bnd-k'), i=c.querySelector('input');
    var have=!!inCart[String(c.dataset.variant)];
    c.classList.toggle('bnd-have',have);
    if(i) i.checked=!have;
    if(k) k.textContent = have ? 'Already in your basket' : (k.dataset.k||k.textContent);
  }
  fetch('/cart.js',{headers:{'Accept':'application/json'}})
    .then(function(r){ return r.json(); })
    .then(function(cart){
      (cart.items||[]).forEach(function(i){ inCart[String(i.variant_id)]=true; });
      cards().forEach(mark); sync();
    }).catch(function(){});

  cta.addEventListener('click',function(){
    var T=window.SolveTheme||{}, addUrl=T.cartAddUrl||'/cart/add.js', cartUrl=T.cartUrl||'/cart';
    var sel=picked();
    if(!sel.length){ if(!(window.SolveCart && SolveCart.open())) window.location=cartUrl; return; }
    var items=sel.map(function(c){ return {id:parseInt(c.dataset.variant,10),quantity:1}; })
                 .filter(function(i){ return i.id; });
    if(!items.length) return;
    /* the discount is applied by navigating through Shopify's own /discount/
       endpoint, so the basket shows the reduced line prices rather than making
       the visitor take the saving on trust until checkout. */
    var dest = items.length>=MIN
      ? '/discount/'+encodeURIComponent(CODE)+'?redirect='+cartUrl
      : cartUrl;
    var old=cta.innerHTML; cta.disabled=true; cta.innerHTML='Adding&hellip;';
    fetch(addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
                  body:JSON.stringify({items:items})})
      .then(function(r){ if(!r.ok) throw r; return r.json(); })
      .then(function(){ try{ (window.dataLayer=window.dataLayer||[]).push({event:'system_add',system:cta.getAttribute('data-system')||'',items:items.length}); }catch(e){}
        cta.innerHTML='Added ✓';
        setTimeout(function(){ var S=window.SolveCart;
          if(S && S.ready()) S.go(dest,cartUrl,function(){ cta.disabled=false; cta.innerHTML=old; }); else window.location=dest; },350); })
      .catch(function(){ cta.disabled=false; cta.innerHTML=old; });
  });

  sync();
})();



/* 58C16 · mobile sheet thumbnails, filled from the live catalogue.
   The rows ship without an <img> so the menu is a complete text menu even if
   this never runs, and so a thumbnail can only ever be a product the store
   actually stocks. data-thumb is "cat:<category>" or "fmt:<format>", matching
   MMDATA[9] and MMDATA[2]; a bestseller wins the slot where there is one. */
(function(){
  if(typeof MMDATA==='undefined'||!MMDATA.length) return;
  [].forEach.call(document.querySelectorAll('.shr[data-thumb]'),function(a){
    var spec=a.getAttribute('data-thumb').split(':'),
        idx=spec[0]==='fmt'?2:9, want=spec[1],
        fig=a.querySelector('figure');
    if(!fig||fig.firstChild) return;
    var pool=MMDATA.filter(function(x){return x[idx]===want&&x[6];});
    if(!pool.length) return;
    var best=pool.filter(function(x){return x[7]===1;});
    var pick=(best.length?best:pool)[0];
    var im=new Image();
    im.loading='lazy'; im.decoding='async'; im.alt=''; im.src=pick[6];
    fig.appendChild(im);
  });
})();


/* 58C18 · mobile sheet drill-down, with a format toggle.
   A category row opens the products in that category INSIDE the sheet rather
   than navigating away. Capsules / Powder / Drops used to sit at the top level
   beside Mushrooms even though all twenty mushrooms ARE those three formats -
   they are a filter here instead, so the same jar is reachable one way only.

   The row keeps its real href, so the menu works with JS off and the link stays
   crawlable; this intercepts, it does not replace. */
(function(){
  var sheet=document.getElementById('sheet'), panel=document.getElementById('shd');
  if(!sheet||!panel||typeof MMDATA==='undefined'||!MMDATA.length) return;
  var list=document.getElementById('shdList'), title=document.getElementById('shdTitle'),
      all=document.getElementById('shdAll'), fmtBar=document.getElementById('shdFmt');
  var COL={fmt:2, cat:9, time:10};
  /* only the three delivery formats are offered as a filter - "health" or
     "sport" are how a product is classified, not a way to take it */
  var FMT=[{k:'caps',   label:'Capsules', url:'/collections/capsules'},
           {k:'powder', label:'Powder',   url:'/collections/powders'},
           {k:'drops',  label:'Drops',    url:'/collections/drops'}];
  var cur={items:[], active:null, href:'/collections/shop-all', kind:''};

  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(ch){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch];});}

  function paint(){
    var shown = cur.active
      ? cur.items.filter(function(x){return x[2]===cur.active;})
      : cur.items;
    list.innerHTML = shown.length ? shown.map(function(x){
      return '<a href="'+esc(x[5])+'">'+
        '<figure>'+(x[6]?'<img loading="lazy" decoding="async" src="'+esc(x[6])+'" alt="">':'')+'</figure>'+
        '<span class="t"><b>'+esc(x[0])+'</b><span>'+esc(x[1])+'</span></span>'+
        '<span class="pr">'+esc(x[4])+'</span></a>';
    }).join('') : '<p class="shd-empty">Nothing here right now.</p>';

    var f = cur.active && FMT.filter(function(o){return o.k===cur.active;})[0];
    all.setAttribute('href', f ? f.url : cur.href);
    all.textContent = cur.noCount ? 'Shop best sellers →'
                                  : 'View all '+shown.length+' →';
  }

  function buildFmt(kind){
    /* Format is how you TAKE a mushroom, so it is only an axis for a
       category drill. A time of day spans all three formats, and
       filtering it would have hidden 10 of Morning's 11 products
       behind a control nobody asked for. */
    var present = (kind==='cat' || (kind==='col' && cur.want==='mushrooms')) ? FMT.filter(function(o){
      return cur.items.some(function(x){return x[2]===o.k;});
    }) : [];
    if(present.length<2){ fmtBar.hidden=true; fmtBar.innerHTML=''; cur.active=null; return; }
    var hasCaps=present.some(function(o){return o.k==='caps';});
    cur.active = hasCaps ? 'caps' : present[0].k;
    fmtBar.innerHTML=present.map(function(o){
      var n=cur.items.filter(function(x){return x[2]===o.k;}).length;
      return '<button type="button" class="shd-f'+(o.k===cur.active?' on':'')+
             '" data-f="'+o.k+'">'+o.label+'<i>'+n+'</i></button>';
    }).join('');
    fmtBar.hidden=false;
  }

  function open(row){
    var spec=(row.getAttribute('data-drill')||'').split(':'),
        kind=spec[0], want=spec[1];
    if(kind==='best'){
      /* the collection, not the mm_best flag — see the desktop tile */
      cur.items=MMDATA.filter(function(x){return (x[11]||[]).indexOf('best-sellers')>-1;});
      cur.noCount=true;
    } else if(kind==='col'){
      /* a collection by its handle: what the taxonomy's rows use, so the phone list is the collection page's list */
      cur.items=MMDATA.filter(function(x){return (x[11]||[]).indexOf(want)>-1;});
      cur.noCount=want==='best-sellers'; cur.want=want;
    } else {
      var col=COL[kind];
      if(col===undefined) return false;
      cur.items=MMDATA.filter(function(x){return x[col]===want;});
    }
    cur.kind=kind;
    if(!cur.items.length) return false;
    cur.href=row.getAttribute('href')||'/collections/shop-all';
    title.textContent=(row.querySelector('b')||{}).textContent||'';
    buildFmt(kind); paint();
    panel.hidden=false; sheet.classList.add('drill'); panel.scrollTop=0;
    return true;
  }

  function close(){ sheet.classList.remove('drill'); panel.hidden=true; }

  sheet.addEventListener('click',function(e){
    var f=e.target.closest&&e.target.closest('.shd-f');
    if(f){ e.preventDefault();
      cur.active=f.getAttribute('data-f');
      [].forEach.call(fmtBar.children,function(b){
        b.classList.toggle('on', b===f); });
      paint(); return; }
    var row=e.target.closest&&e.target.closest('.shr[data-drill]');
    if(row){ if(open(row)) e.preventDefault(); return; }
    if(e.target.closest('#shdBack')){ e.preventDefault(); close(); }
  });

  if(document.getElementById('openMenu'))
    document.getElementById('openMenu').addEventListener('click',close);
  if(document.getElementById('closeMenu'))
    document.getElementById('closeMenu').addEventListener('click',close);
  addEventListener('keydown',function(e){
    if(e.key==='Escape'&&sheet.classList.contains('drill')) close();
  });
})();


/* The "Shop with AI" pill (Microsoft Clarity Brand Agents, app embed) draws itself inside its own
   shadow root in Barlow, white, centred. This gives it the house look (ink pill, acid badge, our type),
   moves it to the bottom right corner on desktop and shows "solvelabs.world" where the app prints the
   store handle "06F88a". The app's own settings could not be reached, so it is done here (8 Oct 2026). */
(function(){
  var CSS=':host{font-family:"Helvetica Neue","Helvetica Now Text","Neue Haas Grotesk",Inter,Arial,sans-serif !important;--accent:#242020 !important}'
    +'.entrypoint-shadow{border-color:#242020 !important}'
    +'.entrypoint-shadow>.bg-white{background:#242020 !important;color:#FCFCF7 !important}'
    +'.entrypoint-shadow .text-foreground-1{color:#FCFCF7 !important;font-weight:500;letter-spacing:.01em}'
    +'.entrypoint-shadow .bg-white :is(button,svg):not(.agent-avatar-sparkle){color:#FCFCF7 !important}'
    +'.agent-avatar-bg{background:#E0FF66 !important;animation:none !important}'
    +'.agent-avatar-sparkle{color:#242020 !important}'
    +'.entrypoint-beam-dot{background:radial-gradient(closest-side,#E0FF66,transparent) !important}'
    +'@media (min-width:990px){.fixed.bottom-0.left-1\\/2{left:auto !important;right:24px !important;translate:none !important;transform:none !important}}';
  var RE=/06F88a(?: AI)?/g, NAME='solvelabs.world';
  function name(root){
    var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT), n;
    while((n=w.nextNode())){ if(n.nodeValue.indexOf('06F88a')>-1) n.nodeValue=n.nodeValue.replace(RE,NAME); }
    root.querySelectorAll('[placeholder*="06F88a"]').forEach(function(e){ e.setAttribute('placeholder',e.getAttribute('placeholder').replace(RE,NAME)); });
  }
  function dress(){
    var host=document.getElementById('ads-agent-host'), sr=host&&host.shadowRoot;
    if(!sr) return false;
    if(sr.getElementById('solve-agent')) return true;
    var s=document.createElement('style'); s.id='solve-agent'; s.textContent=CSS; sr.appendChild(s);
    name(sr);
    new MutationObserver(function(){ name(sr); }).observe(sr,{childList:true,subtree:true,characterData:true});
    return true;
  }
  var tries=0, t=setInterval(function(){ if(dress()||++tries>60) clearInterval(t); },500);
})();
